// ---- Multi-step + booking logic ----

  document.addEventListener("DOMContentLoaded", function() {
    // BACKEND URL -> check dat dit overeenkomt met je Render service
    var apiBaseUrl =
      (window.URBIXX_BOOKING_CONFIG && window.URBIXX_BOOKING_CONFIG.apiBaseUrl)
        ? window.URBIXX_BOOKING_CONFIG.apiBaseUrl
        : "https://urbixx-booking-backend.onrender.com";

    var calculateBtn = document.getElementById("calculate-price-btn");
    var continueBtn = document.getElementById("confirm-booking-btn");
    var showMapBtn = document.getElementById("urbixx-show-map-btn");
    var recalcBtn = document.getElementById("urbixx-recalculate-btn");
    var priceResult = document.getElementById("price-result");
    var routeHint = document.getElementById("urbixx-route-hint-mobile");

    var step1 = document.getElementById("urbixx-step-1");
    var onboardingStep = document.getElementById("urbixx-onboarding-step");
    var step2 = document.getElementById("urbixx-step-2");
    var backBtn = document.getElementById("summary-back-btn");
    var onboardingBackBtn = document.getElementById("onboarding-back-btn");
    var onboardingContinueBtn = document.getElementById("onboarding-continue-btn");
    var finalBookingBtn = document.getElementById("final-booking-btn");

    var bookingMessageStep2 = document.getElementById("booking-message-step2");

    var paymentLinkWrapper = document.getElementById("urbixx-payment-link-wrapper");
    var paymentFullLink = document.getElementById("urbixx-payment-full-link");
    var paymentDepositLink = document.getElementById("urbixx-payment-deposit-link");
    var calendarLinkWrapper = document.getElementById("urbixx-gcal-link-wrapper");
    var calendarLink = document.getElementById("urbixx-gcal-link");
    var reservationsAfterWrapper = document.getElementById("urbixx-reservations-after-wrapper");

    var bookingIdWrapper = document.getElementById("urbixx-booking-id-wrapper");
    var bookingIdValue = document.getElementById("urbixx-booking-id-value");

    var dateTimeSection = document.getElementById("urbixx-date-time-section");
    var returnSection = document.getElementById("urbixx-return-section");

    var pickupInput = document.getElementById("pickup-address");
    var dropoffInput = document.getElementById("dropoff-address");

    // Popular hotels modal (live availability)
    var hotelsBtn = document.getElementById("urbixx-hotels-btn");
    var hotelsModal = document.getElementById("urbixx-hotels-modal");
    var hotelsUpdatedEl = document.getElementById("urbixx-hotels-updated");
    var hotelsNoteEl = document.getElementById("urbixx-hotels-note");
    var hotelsListEl = document.getElementById("urbixx-hotels-list");
    var hotelsMoreBtn = document.getElementById("urbixx-hotels-more");
    var hotelsPollTimer = null;

    var hotelsState = {
      token: 0,
      originLatLng: null,
      results: [],
      driveElements: [],
      shown: 5,
      max: 50,
      fetching: false,
      pagination: null
    };

    // Route panel + controls
    var mapPanel = document.getElementById("urbixx-map-panel");
    var mapEl = document.getElementById("urbixx-map");
    var mapShowPickupBtn = document.getElementById("urbixx-map-show-pickup");
    var mapShowDropoffBtn = document.getElementById("urbixx-map-show-dropoff");
    var mapReplayBtn = document.getElementById("urbixx-map-replay");
    var mapContinueTopBtn = document.getElementById("urbixx-map-continue-top");
    var mapContinueBottomBtn = document.getElementById("urbixx-map-continue-bottom");
    var mapFareEl = document.getElementById("urbixx-map-fare");

    function urbixxGetLastLeg() {
      try {
        if (!urbixxLastRouteResult || !urbixxLastRouteResult.routes || !urbixxLastRouteResult.routes[0]) return null;
        var r = urbixxLastRouteResult.routes[0];
        if (!r.legs || !r.legs[0]) return null;
        return r.legs[0];
      } catch (e) {
        return null;
      }
    }

    function urbixxZoomForDistanceKm(km) {
      var d = Number(km);
      if (!isFinite(d) || d <= 0) return 20;
      if (d <= 2) return 20;
      if (d <= 5) return 19;
      if (d <= 10) return 18;
      if (d <= 20) return 17;
      if (d <= 40) return 16;
      if (d <= 80) return 15;
      if (d <= 160) return 14;
      return 13;
    }

    function urbixxOpenMapPanel() {
      try {
        if (!mapPanel) return;
        mapPanel.classList.add("urbixx-open");
        mapPanel.setAttribute("aria-hidden", "false");
      } catch (e) {}
    }

    function urbixxCloseMapPanel() {
      try {
        if (!mapPanel) return;
        mapPanel.classList.remove("urbixx-open");
        mapPanel.setAttribute("aria-hidden", "true");
      } catch (e) {}
    }

    // Close when clicking the dark backdrop (but not when clicking the dialog)
    if (mapPanel) {
      mapPanel.addEventListener("click", function(e) {
        try {
          if (e && e.target === mapPanel) {
            urbixxCloseMapPanel();
            if (showMapBtn) showMapBtn.textContent = "Show map";
          }
        } catch (err) {}
      });
    }
    var mapInner = document.getElementById("urbixx-map-panel-inner");
    if (mapInner) {
      mapInner.addEventListener("click", function(e) {
        try { if (e) e.stopPropagation(); } catch (err) {}
      });
    }

    function urbixxProceedFromMap() {
      try {
        urbixxCloseMapPanel();
        if (showMapBtn) showMapBtn.textContent = "Show map";
        if (continueBtn) continueBtn.click();
      } catch (e) {}
    }

    function urbixxPrepareReplayStartView(result) {
      try {
        if (!result || !result.routes || !result.routes[0] || !urbixxMap) return null;
        var route = result.routes[0];
        var path = route.overview_path || [];
        if (!path || path.length < 2) return null;
        var start = path[0];

        // Ensure labels are back (end of animation may swap Drop-off to finish flag)
        try { if (urbixxRouteFinishMarker) urbixxRouteFinishMarker.setMap(null); } catch (e0) {}
        try { if (urbixxRouteDropoffMarker) urbixxRouteDropoffMarker.setMap(urbixxMap); } catch (e1) {}
        try { if (urbixxRoutePickupMarker) urbixxRoutePickupMarker.setMap(urbixxMap); } catch (e2) {}
        return start;
      } catch (e) {
        return null;
      }
    }

    // Show map (next to Continue) - re-open the panel if user closed it
    if (showMapBtn) {
      showMapBtn.addEventListener("click", function() {
        try {
          if (mapPanel && mapPanel.classList.contains("urbixx-open")) {
            urbixxCloseMapPanel();
            showMapBtn.textContent = "Show map";
            return;
          }

          urbixxOpenMapPanel();
          showMapBtn.textContent = "Close map";

          // If route state was lost somehow, rebuild from current inputs
          if (!urbixxLastRouteResult) {
            var p = (pickupInput && pickupInput.value) || "";
            var d = (dropoffInput && dropoffInput.value) || "";
            if (p && d) urbixxShowRoute(p, d);
          } else if (urbixxLastRouteResult.routes && urbixxLastRouteResult.routes[0] && urbixxLastRouteResult.routes[0].bounds && urbixxMap) {
            // Keep a consistent framing when reopening
            try { urbixxMap.fitBounds(urbixxLastRouteResult.routes[0].bounds, { top: 60, right: 60, bottom: 60, left: 60 }); } catch (eFit) {}
          }
        } catch (e) {}
      });
    }

    if (mapContinueTopBtn) {
      mapContinueTopBtn.addEventListener("click", function() {
        urbixxProceedFromMap();
      });
    }
    if (mapContinueBottomBtn) {
      mapContinueBottomBtn.addEventListener("click", function() {
        urbixxProceedFromMap();
      });
    }

    if (mapShowPickupBtn) {
      mapShowPickupBtn.addEventListener("click", function() {
        try {
          var leg = urbixxGetLastLeg();
          if (!leg || !urbixxMap) return;
          urbixxOpenMapPanel();
          if (leg.start_location) {
            var km = (leg.distance && leg.distance.value ? (leg.distance.value / 1000) : (lastQuote && lastQuote.distanceKm));
            urbixxMap.setZoom(urbixxZoomForDistanceKm(km));
            urbixxMap.setCenter(leg.start_location);
          }
        } catch (e) {}
      });
    }

    if (mapShowDropoffBtn) {
      mapShowDropoffBtn.addEventListener("click", function() {
        try {
          var leg = urbixxGetLastLeg();
          if (!leg || !urbixxMap) return;
          urbixxOpenMapPanel();
          if (leg.end_location) {
            var km = (leg.distance && leg.distance.value ? (leg.distance.value / 1000) : (lastQuote && lastQuote.distanceKm));
            urbixxMap.setZoom(urbixxZoomForDistanceKm(km));
            urbixxMap.setCenter(leg.end_location);
          }
        } catch (e) {}
      });
    }

    if (mapReplayBtn) {
      mapReplayBtn.addEventListener("click", function() {
        try {
          if (!urbixxLastRouteResult || !mapEl) return;
          urbixxOpenMapPanel();
          // Replay should keep the SAME overview zoom/framing (no jumpy close-up camera).
          // 1) restore markers, 2) fitBounds to last route bounds, 3) start replay after map settles.
          urbixxPrepareReplayStartView(urbixxLastRouteResult);

          var startReplay = function() {
            try { urbixxStartRouteAnimation(urbixxLastRouteResult, mapEl, { followCamera: false }); } catch (e2) {}
          };

          try {
            var r0 = urbixxLastRouteResult && urbixxLastRouteResult.routes && urbixxLastRouteResult.routes[0];
            var b = r0 && r0.bounds ? r0.bounds : null;
            if (b && urbixxMap && window.google && google.maps) {
              // Ensure Google Maps recalculates viewport dimensions (prevents different zoom per replay).
              try { if (google.maps.event && google.maps.event.trigger) google.maps.event.trigger(urbixxMap, "resize"); } catch (eResize) {}
              try { urbixxMap.fitBounds(b, { top: 60, right: 60, bottom: 60, left: 60 }); } catch (eFit) {}
              // Start only once the camera/tiles settle to avoid the "wrong zoom" flash.
              if (google.maps.event && google.maps.event.addListenerOnce) {
                try { google.maps.event.addListenerOnce(urbixxMap, "idle", startReplay); } catch (eIdle) { startReplay(); }
              } else {
                startReplay();
              }
            } else {
              startReplay();
            }
          } catch (ePrep) {
            startReplay();
          }
        } catch (e) {}
      });
    }

    // Book again: prefill from URL params (used by Reservations page)
    (function applyBookAgainParams() {
      try {
        if (typeof URLSearchParams === "undefined") return;
        var params = new URLSearchParams(window.location.search || "");
        var p = params.get("urbixxPickup");
        var d = params.get("urbixxDropoff");
        if (!p && !d) return;

        // Silent fill: don't trigger Google Places suggestions
        if (p) setFieldValue(pickupInput, p, { emitInput: false, emitChange: true });
        if (d) setFieldValue(dropoffInput, d, { emitInput: false, emitChange: true });

        // Important: at this point, the widget hasn't finished wiring its listeners yet.
        // Defer the "addresses changed" flow so date/time auto-opens, distance computes,
        // and the "Calculate fare" button behaves normally.
        setTimeout(function() {
          try {
            if (typeof maybeOpenDateTime === "function") {
              maybeOpenDateTime();
            }
          } catch (e1) {}

          // Distance Matrix may not be ready yet (Google loads async). Retry briefly.
          (function retryDistanceUntilGoogle(attempt) {
            try {
              var maxAttempts = 24; // ~12s total
              if (attempt > maxAttempts) return;
              var googleReady = !!(window.google && google.maps && google.maps.DistanceMatrixService);
              if (!googleReady) {
                return setTimeout(function() {
                  retryDistanceUntilGoogle(attempt + 1);
                }, 500);
              }
              if (typeof scheduleDistanceUpdate === "function") {
                scheduleDistanceUpdate();
              }
            } catch (e2) {}
          })(0);
        }, 0);

        // Bring widget into view
        var widget = document.getElementById("urbixx-booking-widget");
        if (widget) {
          setTimeout(function() {
            widget.scrollIntoView({ behavior: "smooth", block: "start" });
          }, 120);
        }

        // Clean URL (keep hash)
        var cleanUrl = window.location.pathname + (window.location.hash || "");
        window.history.replaceState({}, document.title, cleanUrl);
      } catch (e) {
        // no-op
      }
    })();

    // Toggles
    var returnToggle = document.getElementById("urbixx-return-toggle");
    var waitToggle = document.getElementById("urbixx-wait-toggle");
    var returnStatus = document.getElementById("urbixx-return-status");
    var waitStatus = document.getElementById("urbixx-wait-status");

    // Summary elements
    var summaryTripType = document.getElementById("summary-trip-type");
    var summaryRoute = document.getElementById("summary-route");
    var summaryDatetime = document.getElementById("summary-datetime");
    var summaryReturnRow = document.getElementById("summary-return-row");
    var summaryReturnDatetime = document.getElementById("summary-return-datetime");
    var summaryPassengers = document.getElementById("summary-passengers");
    var summaryWait = document.getElementById("summary-wait");
    var summaryPrice = document.getElementById("summary-price");
    var summaryDistance = document.getElementById("summary-distance");
    var summaryDuration = document.getElementById("summary-duration");
    var summaryRouteDesc = document.getElementById("summary-route-desc");
    var summarySuggestion = document.getElementById("summary-suggestion");
    var summaryCostEv = document.getElementById("summary-cost-ev");
    var summaryCostPetrol = document.getElementById("summary-cost-petrol");
    var summaryCostDiesel = document.getElementById("summary-cost-diesel");
    var co2Text = document.getElementById("urbixx-co2-text");

    // cost & CO2 estimates
    var COST_PER_KM_EV = 0.20;
    var COST_PER_KM_PETROL = 0.30;
    var COST_PER_KM_DIESEL = 0.28;

    var CO2_PETROL_PER_KM = 0.192;
    var CO2_DIESEL_PER_KM = 0.171;
    var lastQuote = null;
    var dateTimeOpen = false;
    var selectedExtras = [];
    var selectedBeverages = [];
    var selectedSnacks = [];
    var extrasTotalPrice = 0;

    function openDateTimeSection(opts) {
      opts = opts || {};
      var shouldScroll = opts.scroll !== false;
      if (!dateTimeOpen) {
        dateTimeSection.classList.add("urbixx-open");
        dateTimeOpen = true;
        if (shouldScroll) {
          // Only scroll if the section is not already visible in viewport
          // Check if element is in viewport before scrolling
          var rect = dateTimeSection.getBoundingClientRect();
          var isVisible = rect.top >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
          if (!isVisible) {
            dateTimeSection.scrollIntoView({ behavior: "smooth", block: "nearest" });
          }
        }
      }
    }

    // Automatisch date/time slide-out als beide adressen gevuld zijn
    // Only trigger on blur/change, not on input (to prevent scrolling while typing)
    function maybeOpenDateTime() {
      var pickupFilled = pickupInput && pickupInput.value.trim().length > 0;
      var dropoffPendingBusiness =
        !!(dropoffInput && dropoffInput.dataset && dropoffInput.dataset.urbixxBusinessPending === "1");
      var dropoffFilled = dropoffInput && dropoffInput.value.trim().length > 0 && !dropoffPendingBusiness;
      if (pickupFilled && dropoffFilled && !dateTimeOpen) {
        // When triggered by field selection (e.g. Google Places), open without scrolling
        openDateTimeSection({ scroll: false });
      }
      // Keep inline distance under Drop-off updated whenever addresses change
      scheduleDistanceUpdate();
      // Show/hide flight number fields if either address is an airport
      updateFlightFieldsVisibility();
    }

    // Only use blur and change events, not input (prevents scrolling while typing)
    if (pickupInput) {
      ["change"].forEach(function(evt) {
        pickupInput.addEventListener(evt, maybeOpenDateTime);
      });
    }
    if (dropoffInput) {
      ["change"].forEach(function(evt) {
        dropoffInput.addEventListener(evt, maybeOpenDateTime);
      });
    }

    // --- Urbixx: Quick destinations + Locations dropdown + current location (Pickup) ---
    var isDutch = (document.documentElement.lang || "").toLowerCase().indexOf("nl") === 0;

    var STRINGS = {
      locateIdle: isDutch ? "Gebruik mijn locatie" : "Use my location",
      locateLoading: isDutch ? "Locatie ophalen\u2026" : "Locating\u2026",
      locateNoSupport: isDutch ? "Locatie is niet beschikbaar in deze browser." : "Location is not available in this browser.",
      locateNoGoogle: isDutch ? "Google Maps is nog niet geladen. Probeer het zo opnieuw." : "Google Maps is not loaded yet. Please try again.",
      locateDenied: isDutch ? "Locatie toegang geweigerd." : "Location access denied.",
      locateFailed: isDutch ? "Kon je locatie niet ophalen. Probeer het opnieuw." : "Could not get your location. Please try again.",
      distanceLabel: isDutch ? "Afstand" : "Distance",
      distancePlaceholder: isDutch ? "Afstand: \u2014 km \u2022 \u00B1\u2014 min" : "Distance: \u2014 km \u2022 ~\u2014 min",
      durationLabel: isDutch ? "Duur" : "Duration",
      approxPrefix: isDutch ? "\u00B1" : "~",
      flightLabelPickup: isDutch ? "Vluchtnummer" : "Flight number",
      flightLabelDropoff: isDutch ? "Vluchtnummer" : "Flight number",
      flightPromptPickup: isDutch ? "Vul je vluchtnummer in (verplicht)" : "Fill in flight number (mandatory)",
      flightPromptDropoff: isDutch ? "Vul je vluchtnummer in (optioneel)" : "Fill in flight number (optional)",
      businessTitle: isDutch ? "Dichtbij jou" : "Nearby matches",
      businessSearching: isDutch ? "Zoeken in de buurt\u2026" : "Searching nearby\u2026",
      businessLoadMore: isDutch ? "Meer tonen" : "Load more",
      businessNoResults: isDutch ? "Geen locaties gevonden in de buurt. Probeer je zoekterm specifieker te maken." : "No nearby matches found. Try a more specific search.",
      businessTipBetter: isDutch ? "Voor betere resultaten in de buurt: vul je pickup-adres in." : "For better nearby results: set your pickup address.",
      businessUsingGps: isDutch ? "Pickup is automatisch gezet op je locatie voor betere resultaten." : "Pickup was set to your location for better results.",
      businessNeedPickupOrGps: isDutch ? "Vul eerst je pickup-adres in of sta locatie toe." : "Please enter a pickup address or allow location access.",
      openUntil: isDutch ? "Geopend tot" : "Open until",
      closedNow: isDutch ? "Gesloten" : "Closed",
      open24h: isDutch ? "24/7 open" : "Open 24/7",
      houseNumberHint: isDutch ? "Tip: voeg een huisnummer toe om suggesties te zien." : "Tip: add a house number to see suggestions.",
      timePlus30: isDutch ? "+30 min" : "+30 min",
      timePlus60: isDutch ? "+1 uur" : "+1 hour",
      timePlus90: isDutch ? "+1,5 uur" : "+1.5 hours",
      timePlus120: isDutch ? "+2 uur" : "+2 hours",
      airportsSelectPlaceholder: isDutch ? "Kies een luchthaven\u2026" : "Choose an airport\u2026",
      locationsSelectPlaceholder: isDutch ? "Kies een locatie\u2026" : "Choose a location\u2026",
      stationsSelectPlaceholder: isDutch ? "Kies een station\u2026" : "Choose a station\u2026"
    };

    function setFieldValue(inputEl, value, opts) {
      if (!inputEl) return;
      opts = opts || {};
      var emitInput = opts.emitInput !== false;   // default true
      var emitChange = opts.emitChange !== false; // default true
      var blur = !!opts.blur;

      inputEl.value = value;

      try {
        if (emitInput) inputEl.dispatchEvent(new Event("input", { bubbles: true }));
        if (emitChange) inputEl.dispatchEvent(new Event("change", { bubbles: true }));
      } catch (e) {
        // older browsers fallback
        if (emitInput) {
          var ev1 = document.createEvent("Event");
          ev1.initEvent("input", true, true);
          inputEl.dispatchEvent(ev1);
        }
        if (emitChange) {
          var ev2 = document.createEvent("Event");
          ev2.initEvent("change", true, true);
          inputEl.dispatchEvent(ev2);
        }
      }

      if (blur) {
        try { inputEl.blur(); } catch (e3) {}
      }
    }

    // --- Premium date/time UX (confirm animations + quick time offsets) ---
    var pickupDateEl = document.getElementById("pickup-date");
    var pickupTimeEl = document.getElementById("pickup-time");
    var returnDateEl = document.getElementById("return-date");
    var returnTimeEl = document.getElementById("return-time");

    function getDtShell(inputEl) {
      try {
        return inputEl && inputEl.closest ? inputEl.closest(".urbixx-dt-shell") : null;
      } catch (e) {
        return null;
      }
    }

    function setDtState(inputEl) {
      var shell = getDtShell(inputEl);
      if (!shell) return;
      var filled = !!(inputEl && inputEl.value && String(inputEl.value).trim());
      if (filled) shell.classList.add("is-filled");
      else shell.classList.remove("is-filled");
    }

    function flashDtConfirm(inputEl) {
      var shell = getDtShell(inputEl);
      if (!shell) return;
      shell.classList.remove("is-confirmed");
      try { void shell.offsetWidth; } catch (e) {}
      shell.classList.add("is-confirmed");
      window.setTimeout(function() {
        try { shell.classList.remove("is-confirmed"); } catch (e2) {}
      }, 900);
    }

    [pickupDateEl, pickupTimeEl, returnDateEl, returnTimeEl].forEach(function(el) {
      if (!el) return;
      setDtState(el);
      el.addEventListener("change", function() {
        setDtState(el);
        flashDtConfirm(el);
      });
      el.addEventListener("input", function() {
        setDtState(el);
      });
    });

    function pad2(n) { return String(n).padStart(2, "0"); }
    function toDateValue(d) { return d.getFullYear() + "-" + pad2(d.getMonth() + 1) + "-" + pad2(d.getDate()); }
    function toTimeValue(d) { return pad2(d.getHours()) + ":" + pad2(d.getMinutes()); }

    function addMinutesRounded(baseDate, minutesToAdd) {
      var d = new Date(baseDate.getTime());
      d.setMinutes(d.getMinutes() + (parseInt(minutesToAdd, 10) || 0));
      // Round up to 5-minute steps for a cleaner UX
      var m = d.getMinutes();
      var rounded = Math.ceil(m / 5) * 5;
      if (rounded === 60) {
        d.setHours(d.getHours() + 1);
        d.setMinutes(0);
      } else {
        d.setMinutes(rounded);
      }
      return d;
    }

    function applyQuickOffset(dateEl, timeEl, offsetMin) {
      if (!dateEl || !timeEl) return;
      var now = new Date();
      var target = addMinutesRounded(now, offsetMin);
      var todayStr = toDateValue(now);

      // If date is empty OR user selected today, keep it aligned with "from now" (handles midnight crossover)
      if (!dateEl.value || String(dateEl.value) === todayStr) {
        setFieldValue(dateEl, toDateValue(target), { emitInput: false, emitChange: true });
      }
      setFieldValue(timeEl, toTimeValue(target), { emitInput: false, emitChange: true, blur: true });
    }

    function localizeTimeChips() {
      var btns = document.querySelectorAll("[data-urbixx-time-offset]");
      Array.prototype.forEach.call(btns, function(b) {
        var off = parseInt(b.getAttribute("data-urbixx-time-offset") || "0", 10);
        if (off === 30) b.textContent = STRINGS.timePlus30;
        else if (off === 60) b.textContent = STRINGS.timePlus60;
        else if (off === 90) b.textContent = STRINGS.timePlus90;
        else if (off === 120) b.textContent = STRINGS.timePlus120;
      });
    }

    function initTimeChips() {
      localizeTimeChips();
      var btns = document.querySelectorAll("[data-urbixx-time-offset]");
      Array.prototype.forEach.call(btns, function(b) {
        b.addEventListener("click", function() {
          var off = parseInt(b.getAttribute("data-urbixx-time-offset") || "0", 10);
          var group = b.closest("[data-urbixx-time-quick]");
          var key = group ? group.getAttribute("data-urbixx-time-quick") : "pickup";
          // Visual selected state (only one at a time per group)
          if (group) {
            var siblings = group.querySelectorAll("[data-urbixx-time-offset]");
            Array.prototype.forEach.call(siblings, function(sib) {
              sib.classList.remove("is-primary");
              sib.setAttribute("aria-pressed", "false");
            });
          }
          b.classList.add("is-primary");
          b.setAttribute("aria-pressed", "true");
          if (key === "return") applyQuickOffset(returnDateEl, returnTimeEl, off);
          else applyQuickOffset(pickupDateEl, pickupTimeEl, off);
        });
      });
    }

    initTimeChips();

    // Clear chip selection if user manually changes time
    function clearTimeChipSelection(which) {
      var group = document.querySelector('[data-urbixx-time-quick="' + which + '"]');
      if (!group) return;
      var chips = group.querySelectorAll("[data-urbixx-time-offset]");
      Array.prototype.forEach.call(chips, function(c) {
        c.classList.remove("is-primary");
        c.setAttribute("aria-pressed", "false");
      });
    }

    if (pickupTimeEl) {
      pickupTimeEl.addEventListener("input", function() { clearTimeChipSelection("pickup"); });
      pickupTimeEl.addEventListener("change", function() { clearTimeChipSelection("pickup"); });
    }
    if (returnTimeEl) {
      returnTimeEl.addEventListener("input", function() { clearTimeChipSelection("return"); });
      returnTimeEl.addEventListener("change", function() { clearTimeChipSelection("return"); });
    }

    // Make our premium icon buttons open the native pickers (when supported)
    (function initDateTimePickers() {
      try {
        var btns = document.querySelectorAll("[data-urbixx-dt-open]");
        Array.prototype.forEach.call(btns, function(btn) {
          btn.addEventListener("click", function(e) {
            e.preventDefault();
            var shell = btn.closest(".urbixx-dt-shell");
            if (!shell) return;
            var input = shell.querySelector("input");
            if (!input) return;
            try {
              if (typeof input.showPicker === "function") input.showPicker();
              else input.focus();
            } catch (e2) {
              try { input.focus(); } catch (e3) {}
            }
          });
        });

        // Add focus class for subtle icon tick animation on time fields
        [pickupDateEl, pickupTimeEl, returnDateEl, returnTimeEl].forEach(function(el) {
          if (!el) return;
          var shell = getDtShell(el);
          if (!shell) return;
          el.addEventListener("focus", function() { shell.classList.add("is-focused"); });
          el.addEventListener("blur", function() { shell.classList.remove("is-focused"); });
        });
      } catch (e) {}
    })();

    // Show Google Places suggestions only when a house number is included (digits in value)
    var pickupHouseHintEl = document.getElementById("urbixx-pickup-househint");
    var dropoffHouseHintEl = document.getElementById("urbixx-dropoff-househint");
    var activeAddressField = null; // "pickup" | "dropoff" | null
    var pacForceHidden = false; // used to collapse the pac dropdown after a selection

    function hasHouseNumber(v) {
      var s = String(v || "").trim();
      // At least one digit (keeps it simple and robust across NL/BE/DE formats)
      return /\d/.test(s);
    }

    function setHint(el, shouldShow) {
      if (!el) return;
      el.textContent = shouldShow ? STRINGS.houseNumberHint : "";
    }

    function getPacContainers() {
      try {
        return Array.prototype.slice.call(document.querySelectorAll(".pac-container"));
      } catch (e) {
        return [];
      }
    }

    function updatePacVisibility() {
      try {
        var pacs = getPacContainers();
        if (!pacs.length) return;

        // If our custom business dropdown is open/pending, Google suggestions must never
        // sit on top (even invisibly). Force-hide the pac container in that state.
        var forceHide =
          !!(typeof businessPanel !== "undefined" && businessPanel && businessPanel.classList && businessPanel.classList.contains("is-open")) ||
          !!(dropoffInput && dropoffInput.dataset && dropoffInput.dataset.urbixxBusinessPending === "1");

        // Also force-hide after a selection until the user types again (prevents the
        // empty "powered by Google" bar from sticking under the field).
        if (pacForceHidden) {
          pacs.forEach(function(p) {
            p.style.display = "none";
            p.style.visibility = "hidden";
            p.style.pointerEvents = "none";
          });
          return;
        }

        var activeEl = document.activeElement;
        var isPickupActive = !!(pickupInput && activeEl === pickupInput);
        var isDropoffActive = !!(dropoffInput && activeEl === dropoffInput);
        var shouldGate = isPickupActive || isDropoffActive;

        if (forceHide) {
          pacs.forEach(function(p) {
            p.style.display = "none";
            p.style.visibility = "hidden";
            p.style.pointerEvents = "none";
          });
          return;
        }

        // If the address field is not actively focused, never show the pac container.
        // This prevents the empty "powered by Google" bar from sticking under inputs.
        if (!shouldGate) {
          pacs.forEach(function(p) {
            p.style.display = "none";
            p.style.visibility = "hidden";
            p.style.pointerEvents = "none";
          });
          return;
        }

        var val = isPickupActive ? (pickupInput.value || "") : (dropoffInput.value || "");
        var allow = hasHouseNumber(val);
        pacs.forEach(function(p) {
          // Only show "powered by Google" when there are actual suggestions to show.
          var hasItems = false;
          try {
            hasItems = !!p.querySelector(".pac-item");
          } catch (e2) {}

          var show = !!allow && !!hasItems;
          p.style.display = show ? "" : "none";
          p.style.visibility = show ? "" : "hidden";
          p.style.pointerEvents = show ? "" : "none";
        });
      } catch (e) {
        // no-op
      }
    }

    function updateHouseHintsAndPac() {
      try {
        setHint(pickupHouseHintEl, pickupInput && !hasHouseNumber(pickupInput.value));
        setHint(dropoffHouseHintEl, dropoffInput && !hasHouseNumber(dropoffInput.value));
      } catch (e) {}
      updatePacVisibility();
    }

    function markAutofill(inputEl, rawValue) {
      if (!inputEl) return "";
      var token = String(Date.now()) + "-" + String(Math.random()).slice(2);
      inputEl.dataset.urbixxAutofillToken = token;
      inputEl.dataset.urbixxAutofillRaw = rawValue || "";
      return token;
    }

    function canApplyAutofill(inputEl, token, rawValue) {
      if (!inputEl) return false;
      if ((inputEl.dataset.urbixxAutofillToken || "") !== String(token || "")) return false;
      // Only apply if the user hasn't typed something else since we filled rawValue
      return (inputEl.value || "") === (rawValue || "");
    }

    // If user types, cancel any pending autofill override
    [pickupInput, dropoffInput].forEach(function(el) {
      if (!el) return;
      el.addEventListener("input", function() {
        try {
          delete el.dataset.urbixxAutofillToken;
          delete el.dataset.urbixxAutofillRaw;
          delete el.dataset.urbixxIsAirport;
          delete el.dataset.urbixxAirportCode;
          delete el.dataset.urbixxAirportName;
        } catch (e) {}
        // User is typing again -> allow the pac dropdown to show (if house number is present)
        pacForceHidden = false;
        updateFlightFieldsVisibility();
        updateHouseHintsAndPac();
      });
    });

    if (pickupInput) {
      pickupInput.addEventListener("focus", function() {
        activeAddressField = "pickup";
        pacForceHidden = false;
        updateHouseHintsAndPac();
      });
      pickupInput.addEventListener("blur", function() {
        activeAddressField = null;
        setTimeout(updatePacVisibility, 0);
      });
      pickupInput.addEventListener("change", function() {
        // After selecting a suggestion, collapse the pac dropdown (it can stick as an empty bar)
        pacForceHidden = true;
        updateHouseHintsAndPac();
      });
    }

    if (dropoffInput) {
      dropoffInput.addEventListener("focus", function() {
        activeAddressField = "dropoff";
        pacForceHidden = false;
        updateHouseHintsAndPac();
      });
      dropoffInput.addEventListener("blur", function() {
        activeAddressField = null;
        setTimeout(updatePacVisibility, 0);
      });
      dropoffInput.addEventListener("change", function() {
        // After selecting a suggestion, collapse the pac dropdown (it can stick as an empty bar)
        pacForceHidden = true;
        updateHouseHintsAndPac();
      });
    }

    // Watch for Google creating / updating the .pac-container
    (function initPacObserver() {
      try {
        if (!window.MutationObserver || !document.body) return;
        var obs = new MutationObserver(function() {
          updatePacVisibility();
        });
        obs.observe(document.body, { childList: true, subtree: true });
      } catch (e) {}
    })();

    // initial hint state
    updateHouseHintsAndPac();

    function getGeocoder() {
      if (!window.google || !google.maps || !google.maps.Geocoder) return null;
      return new google.maps.Geocoder();
    }

    function geocodeAddress(address) {
      return new Promise(function(resolve, reject) {
        var geocoder = getGeocoder();
        if (!geocoder) return reject(new Error("NO_GOOGLE"));
        geocoder.geocode({ address: address }, function(results, status) {
          if (status === "OK" && results && results[0]) {
            resolve(results[0].formatted_address || address);
          } else {
            reject(new Error(status || "GEOCODE_FAILED"));
          }
        });
      });
    }

    function reverseGeocode(lat, lng) {
      return new Promise(function(resolve, reject) {
        var geocoder = getGeocoder();
        if (!geocoder) return reject(new Error("NO_GOOGLE"));
        geocoder.geocode({ location: { lat: lat, lng: lng } }, function(results, status) {
          if (status === "OK" && results && results[0]) {
            resolve(results[0].formatted_address);
          } else {
            reject(new Error(status || "REVERSE_FAILED"));
          }
        });
      });
    }

    function geocodeToLatLng(address) {
      return new Promise(function(resolve, reject) {
        var geocoder = getGeocoder();
        if (!geocoder) return reject(new Error("NO_GOOGLE"));
        geocoder.geocode({ address: address }, function(results, status) {
          try {
            if (status === "OK" && results && results[0] && results[0].geometry && results[0].geometry.location) {
              var loc = results[0].geometry.location;
              resolve({ lat: loc.lat(), lng: loc.lng() });
            } else {
              reject(new Error(status || "GEOCODE_LATLNG_FAILED"));
            }
          } catch (e) {
            reject(e);
          }
        });
      });
    }

    // Inline distance under Drop-off (km, max 2 decimals)
    var inlineDistanceEl = document.getElementById("urbixx-inline-distance");

    function formatKm(km) {
      var num = typeof km === "number" ? km : parseFloat(km);
      if (!isFinite(num)) return null;
      var fixed = num.toFixed(2);
      if (isDutch) fixed = fixed.replace(".", ",");
      return fixed;
    }

    function formatDurationMinutes(mins) {
      var num = typeof mins === "number" ? mins : parseFloat(mins);
      if (!isFinite(num)) return null;
      var m = Math.max(0, Math.round(num));
      if (m < 60) return m + " min";
      var h = Math.floor(m / 60);
      var rem = m % 60;
      if (rem === 0) return h + " h";
      return h + " h " + rem + " min";
    }

    function setInlineDistance(km, minutes) {
      if (!inlineDistanceEl) return;
      var formatted = formatKm(km);
      if (!formatted) {
        inlineDistanceEl.textContent = STRINGS.distancePlaceholder;
        return;
      }
      var dur = formatDurationMinutes(minutes);
      if (dur) {
        inlineDistanceEl.textContent =
          STRINGS.distanceLabel +
          ": " +
          formatted +
          " km \u2022 " +
          STRINGS.approxPrefix +
          dur;
      } else {
        inlineDistanceEl.textContent = STRINGS.distanceLabel + ": " + formatted + " km";
      }
    }

    function computeDistanceInfoViaGoogle(origin, destination) {
      return new Promise(function(resolve, reject) {
        if (!window.google || !google.maps || !google.maps.DistanceMatrixService) {
          return reject(new Error("NO_GOOGLE"));
        }
        var svc = new google.maps.DistanceMatrixService();
        svc.getDistanceMatrix(
          {
            origins: [origin],
            destinations: [destination],
            travelMode: google.maps.TravelMode.DRIVING,
            unitSystem: google.maps.UnitSystem.METRIC
          },
          function(resp, status) {
            try {
              if (status !== "OK" || !resp || !resp.rows || !resp.rows[0] || !resp.rows[0].elements || !resp.rows[0].elements[0]) {
                return reject(new Error(status || "DISTANCE_FAILED"));
              }
              var el = resp.rows[0].elements[0];
              if (el.status !== "OK" || !el.distance || typeof el.distance.value !== "number") {
                return reject(new Error(el.status || "NO_DISTANCE"));
              }
              var km = el.distance.value / 1000;
              var minutes = el.duration && typeof el.duration.value === "number" ? (el.duration.value / 60) : null;
              resolve({ km: km, minutes: minutes });
            } catch (e) {
              reject(e);
            }
          }
        );
      });
    }

    var distanceDebounceTimer = null;
    function scheduleDistanceUpdate() {
      if (!pickupInput || !dropoffInput) return;
      var origin = pickupInput.value.trim();
      var dest = dropoffInput.value.trim();
      if (!origin || !dest) {
        setInlineDistance(null, null);
        return;
      }
      if (distanceDebounceTimer) window.clearTimeout(distanceDebounceTimer);
      distanceDebounceTimer = window.setTimeout(function() {
        computeDistanceInfoViaGoogle(origin, dest)
          .then(function(info) {
            setInlineDistance(info && info.km, info && info.minutes);
          })
          .catch(function() {
            setInlineDistance(null, null);
          });
      }, 350);
    }

    // initialize placeholder
    setInlineDistance(null, null);

    // --- Popular hotels modal (live availability) ---
    function fmtTimeShort(ts) {
      try {
        var d = ts ? new Date(ts) : new Date();
        var hh = String(d.getHours()).padStart(2, "0");
        var mm = String(d.getMinutes()).padStart(2, "0");
        return hh + ":" + mm;
      } catch (e) {
        return "";
      }
    }

    function hotelsSetUpdated(text) {
      try { if (hotelsUpdatedEl) hotelsUpdatedEl.textContent = text || ""; } catch (e) {}
    }

    function hotelsSetNote(text) {
      try { if (hotelsNoteEl) hotelsNoteEl.textContent = text || ""; } catch (e) {}
    }

    function hotelPriceLevelText(level) {
      try {
        var n = typeof level === "number" ? level : parseInt(level, 10);
        if (!isFinite(n) || n < 0) return "";
        var euros = "";
        for (var i = 0; i < Math.min(4, Math.max(0, n + 1)); i++) euros += "\u20AC";
        return euros;
      } catch (e) {
        return "";
      }
    }

    function hotelKmText(meters) {
      var m = typeof meters === "number" ? meters : parseFloat(meters);
      if (!isFinite(m)) return "";
      var km = m / 1000;
      var fixed = km.toFixed(1);
      if (isDutch) fixed = fixed.replace(".", ",");
      return fixed + " km";
    }

    function hotelMinutesText(seconds) {
      var s = typeof seconds === "number" ? seconds : parseFloat(seconds);
      if (!isFinite(s)) return "";
      var mins = Math.max(1, Math.round(s / 60));
      return STRINGS.approxPrefix + mins + " min";
    }

    function getQuickTargetFromUi() {
      try {
        var active = document.querySelector(".urbixx-target-toggle__btn.is-active[data-urbixx-target]");
        var t = active ? active.getAttribute("data-urbixx-target") : "dropoff";
        return t === "pickup" ? "pickup" : "dropoff";
      } catch (e) {
        return "dropoff";
      }
    }

    function openGoogleMapsPlaceUrl(placeId, queryText) {
      try {
        if (placeId) {
          return "https://www.google.com/maps/search/?api=1&query_place_id=" + encodeURIComponent(placeId) + "&query=" + encodeURIComponent(queryText || "hotel");
        }
      } catch (e) {}
      return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(queryText || "hotel");
    }

    function renderHotels(results, driveElements) {
      if (!hotelsListEl) return;
      hotelsListEl.innerHTML = "";

      var hotels = results || [];
      var maxShown = Math.min(hotelsState.max, hotelsState.shown || 5, hotels.length);
      if (!hotels.length) {
        var empty = document.createElement("div");
        empty.style.fontSize = "12px";
        empty.style.fontWeight = "800";
        empty.style.color = "rgba(0,0,0,0.62)";
        empty.textContent = isDutch ? "Geen hotels gevonden." : "No hotels found.";
        hotelsListEl.appendChild(empty);
        return;
      }

      for (var i = 0; i < maxShown; i++) {
        var h = hotels[i] || {};
        var el = driveElements && driveElements[i] ? driveElements[i] : null;
        var distMeters = (el && el.status === "OK" && el.distance && typeof el.distance.value === "number") ? el.distance.value : null;
        var durSeconds = (el && el.status === "OK" && el.duration && typeof el.duration.value === "number") ? el.duration.value : null;

        var card = document.createElement("div");
        card.className = "urbixx-hotel-card";

        var top = document.createElement("div");
        top.className = "urbixx-hotel-card__top";

        var left = document.createElement("div");
        left.className = "urbixx-hotel-card__left";

        if (h.photos && h.photos[0] && typeof h.photos[0].getUrl === "function") {
          var img = document.createElement("img");
          img.className = "urbixx-hotel-thumb";
          img.alt = h.name ? (h.name + " photo") : "Hotel photo";
          try { img.src = h.photos[0].getUrl({ maxWidth: 240, maxHeight: 240 }); } catch (e0) {}
          left.appendChild(img);
        }

        var textWrap = document.createElement("div");
        textWrap.style.minWidth = "0";

        var name = document.createElement("div");
        name.className = "urbixx-hotel-name";
        name.textContent = h.name || "Hotel";

        var city = document.createElement("span");
        city.className = "urbixx-hotel-city";
        city.textContent = h.vicinity || h.formatted_address || "";

        textWrap.appendChild(name);
        if (city.textContent) textWrap.appendChild(city);

        if (typeof h.rating === "number") {
          var rating = document.createElement("div");
          rating.className = "urbixx-hotel-rating";
          var star = document.createElement("span");
          star.className = "urbixx-hotel-rating__star";
          star.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 17.3l-6.18 3.4 1.18-6.9L1.9 8.9l7-1L12 1.6l3.1 6.3 7 1-5.1 4.9 1.18 6.9z"></path></svg>';
          var txt = document.createElement("span");
          var cnt = typeof h.user_ratings_total === "number" ? h.user_ratings_total : null;
          txt.textContent = String(h.rating.toFixed(1)).replace(".", isDutch ? "," : ".") + (cnt ? (" \u2022 " + cnt) : "");
          rating.appendChild(star);
          rating.appendChild(txt);
          textWrap.appendChild(rating);
        }

        left.appendChild(textWrap);

        var pill = document.createElement("div");
        pill.className = "urbixx-hotel-pill is-ok";
        var openTxt = "";
        try {
          if (h.opening_hours && typeof h.opening_hours.open_now === "boolean") {
            openTxt = h.opening_hours.open_now ? (isDutch ? "Open" : "Open") : (isDutch ? "Gesloten" : "Closed");
          }
        } catch (e1) {}
        var priceTxt = hotelPriceLevelText(h.price_level);
        var driveTxt = (distMeters ? hotelKmText(distMeters) : "") + (durSeconds ? (" \u2022 " + hotelMinutesText(durSeconds)) : "");
        var parts = [];
        if (openTxt) parts.push(openTxt);
        if (priceTxt) parts.push(priceTxt);
        if (driveTxt) parts.push(driveTxt);
        pill.textContent = parts.length ? parts.join(" \u2022 ") : (isDutch ? "Hotel" : "Hotel");

        top.appendChild(left);
        top.appendChild(pill);

        var body = document.createElement("div");
        body.className = "urbixx-hotel-rooms";
        var title = document.createElement("div");
        title.className = "urbixx-hotel-rooms__title";
        title.textContent = isDutch ? "Acties" : "Actions";
        body.appendChild(title);

        var actions = document.createElement("div");
        actions.className = "urbixx-hotel-actions";

        var fillBtn = document.createElement("button");
        fillBtn.type = "button";
        fillBtn.className = "urbixx-hotel-link";
        fillBtn.textContent = isDutch ? "Gebruik als locatie" : "Use as location";
        fillBtn.addEventListener("click", function(place) {
          return function() {
            try {
              var t = getQuickTargetFromUi();
              var input = t === "pickup" ? pickupInput : dropoffInput;
              if (!input) return;
              var value = (place && place.name ? place.name + ", " : "") + (place && (place.vicinity || place.formatted_address) ? (place.vicinity || place.formatted_address) : "");
              setFieldValue(input, value, { emitInput: false, emitChange: true, blur: true });
              scheduleDistanceUpdate();
              closeHotelsModal();
            } catch (e) {}
          };
        }(h));

        var mapsLink = document.createElement("a");
        mapsLink.className = "urbixx-hotel-link";
        mapsLink.textContent = isDutch ? "Open in Google" : "Open in Google";
        mapsLink.target = "_blank";
        mapsLink.rel = "noopener noreferrer";
        mapsLink.href = openGoogleMapsPlaceUrl(h.place_id, h.name || "hotel");

        actions.appendChild(fillBtn);
        actions.appendChild(mapsLink);
        body.appendChild(actions);

        card.appendChild(top);
        card.appendChild(body);
        hotelsListEl.appendChild(card);
      }
    }

    function updateHotelsMoreBtn() {
      if (!hotelsMoreBtn) return;
      try {
        hotelsMoreBtn.textContent = isDutch ? "Meer tonen" : "Load more";
        var canShowMoreAlready = hotelsState.results.length > (hotelsState.shown || 5) && (hotelsState.shown || 5) < hotelsState.max;
        var canFetchMore = !!(hotelsState.pagination && hotelsState.pagination.hasNextPage) && hotelsState.results.length < hotelsState.max;
        var shouldShow = canShowMoreAlready || canFetchMore;
        hotelsMoreBtn.style.display = shouldShow ? "inline-flex" : "none";
        hotelsMoreBtn.disabled = !!hotelsState.fetching;
      } catch (e) {}
    }

    function nearbyHotelsPage(originLatLng, pageToken) {
      return new Promise(function(resolve, reject) {
        try {
          var svc = getPlacesService();
          if (!svc) return reject(new Error("NO_PLACES"));
          if (!originLatLng || typeof originLatLng.lat !== "number" || typeof originLatLng.lng !== "number") {
            return reject(new Error("NO_ORIGIN"));
          }
          var loc = new google.maps.LatLng(originLatLng.lat, originLatLng.lng);
          var req = {
            location: loc,
            rankBy: google.maps.places.RankBy.DISTANCE,
            type: "lodging"
          };
          // NOTE: Places pagination works by calling pagination.nextPage(), which triggers the SAME callback again.
          // We therefore store the callback in hotelsState so load-more can request the next page.
          var cb = function(results, status, pagination) {
            try {
              if (status !== google.maps.places.PlacesServiceStatus.OK || !results || !results.length) {
                // If we are waiting for a next page, resolve that waiter; otherwise resolve the init call.
                try {
                  if (hotelsState && hotelsState._pageResolve) {
                    var r0 = hotelsState._pageResolve;
                    hotelsState._pageResolve = null;
                    hotelsState.pagination = pagination || hotelsState.pagination || null;
                    return r0({ results: [], pagination: hotelsState.pagination || null });
                  }
                } catch (e0) {}
                return resolve({ results: [], pagination: pagination || null });
              }

              try {
                if (hotelsState && hotelsState._pageResolve) {
                  var r = hotelsState._pageResolve;
                  hotelsState._pageResolve = null;
                  hotelsState.pagination = pagination || hotelsState.pagination || null;
                  return r({ results: results, pagination: hotelsState.pagination || null });
                }
              } catch (e1) {}

              resolve({ results: results, pagination: pagination || null });
            } catch (e2) {
              try {
                if (hotelsState && hotelsState._pageResolve) {
                  var r2 = hotelsState._pageResolve;
                  hotelsState._pageResolve = null;
                  hotelsState.pagination = pagination || hotelsState.pagination || null;
                  return r2({ results: [], pagination: hotelsState.pagination || null });
                }
              } catch (e3) {}
              resolve({ results: [], pagination: pagination || null });
            }
          };

          hotelsState._nearbyCb = cb;
          svc.nearbySearch(req, cb);
        } catch (e) {
          reject(e);
        }
      });
    }

    function nearbyHotelsNextPage() {
      return new Promise(function(resolve) {
        try {
          if (!hotelsState || !hotelsState.pagination || !hotelsState.pagination.hasNextPage) {
            return resolve({ results: [], pagination: hotelsState ? hotelsState.pagination : null });
          }
          // Set waiter so the stored callback resolves this promise when nextPage results arrive
          hotelsState._pageResolve = resolve;
          hotelsState.pagination.nextPage();
          // Safety timeout: don't hang UI forever if callback doesn't fire
          setTimeout(function() {
            try {
              if (hotelsState && hotelsState._pageResolve === resolve) {
                hotelsState._pageResolve = null;
                resolve({ results: [], pagination: hotelsState.pagination || null });
              }
            } catch (e0) {
              resolve({ results: [], pagination: null });
            }
          }, 3500);
        } catch (e) {
          resolve({ results: [], pagination: hotelsState ? hotelsState.pagination : null });
        }
      });
    }

    async function ensureHotelsDriveElements(uptoCount) {
      try {
        var upto = Math.min(hotelsState.max, Math.max(0, uptoCount || 0), hotelsState.results.length);
        if (!hotelsState.originLatLng) return;
        if (hotelsState.driveElements.length >= upto) return;

        // Fill in drive elements in batches of 10 (Distance Matrix limit)
        while (hotelsState.driveElements.length < upto) {
          var start = hotelsState.driveElements.length;
          var end = Math.min(upto, start + 10);
          var slice = hotelsState.results.slice(start, end);
          var els = [];
          try {
            els = await computeDriveMatrix(hotelsState.originLatLng, slice);
          } catch (e0) {
            els = [];
          }
          // DistanceMatrix returns array length = slice length (or less on failures)
          for (var i = 0; i < slice.length; i++) {
            hotelsState.driveElements[start + i] = els[i] || null;
          }
        }
      } catch (e) {}
    }

    function nearbyHotels(originLatLng) {
      return new Promise(function(resolve, reject) {
        try {
          var svc = getPlacesService();
          if (!svc) return reject(new Error("NO_PLACES"));
          if (!originLatLng || typeof originLatLng.lat !== "number" || typeof originLatLng.lng !== "number") {
            return reject(new Error("NO_ORIGIN"));
          }
          var loc = new google.maps.LatLng(originLatLng.lat, originLatLng.lng);
          svc.nearbySearch(
            {
              location: loc,
              rankBy: google.maps.places.RankBy.DISTANCE,
              type: "lodging"
            },
            function(results, status) {
              try {
                if (status !== google.maps.places.PlacesServiceStatus.OK || !results || !results.length) return resolve([]);
                resolve(results.slice(0, 10));
              } catch (e2) {
                resolve([]);
              }
            }
          );
        } catch (e) {
          reject(e);
        }
      });
    }

    async function fetchHotelsAvailability() {
      try {
        if (!window.google || !google.maps || !google.maps.places) throw new Error("NO_GOOGLE");

        hotelsState.token++;
        var token = hotelsState.token;
        hotelsState.fetching = true;
        hotelsState.results = [];
        hotelsState.driveElements = [];
        hotelsState.shown = 5;
        hotelsState.pagination = null;
        hotelsState.originLatLng = null;
        updateHotelsMoreBtn();

        hotelsSetUpdated(isDutch ? "Hotels in de buurt zoeken\u2026" : "Searching nearby hotels\u2026");
        hotelsSetNote("");

        // Use the same origin logic as the nearby-business dropdown:
        // pickup if possible, otherwise GPS (and silently fill pickup for better future results).
        var originInfo = await getOriginForBusinessSearch();
        if (originInfo && originInfo.source === "gps" && originInfo.shouldFillPickup) {
          try { await ensurePickupFilledFromGps(originInfo.latlng); } catch (e0) {}
        }
        hotelsState.originLatLng = originInfo.latlng;

        hotelsSetNote(isDutch
          ? "Resultaten zijn gebaseerd op je pickup adres (of GPS als pickup leeg is). Kies een hotel om het actieve veld (Pickup/Drop-off) te vullen."
          : "Results are based on your pickup address (or GPS if pickup is empty). Choose a hotel to fill the active field (Pickup/Drop-off).");

        // First page
        var page1 = await nearbyHotelsPage(originInfo.latlng);
        if (token !== hotelsState.token) return;
        hotelsState.pagination = page1.pagination || null;
        hotelsState.results = (page1.results || []).slice(0, hotelsState.max);

        if (!hotelsState.results.length) {
          hotelsSetUpdated(isDutch ? "Geen hotels gevonden in de buurt." : "No nearby hotels found.");
          hotelsState.fetching = false;
          updateHotelsMoreBtn();
          renderHotels([], []);
          return;
        }

        hotelsSetUpdated((isDutch ? "Laatst bijgewerkt om " : "Last updated at ") + fmtTimeShort(Date.now()));

        await ensureHotelsDriveElements(hotelsState.shown);
        if (token !== hotelsState.token) return;

        hotelsState.fetching = false;
        updateHotelsMoreBtn();
        renderHotels(hotelsState.results, hotelsState.driveElements);
      } catch (e) {
        hotelsSetUpdated(isDutch ? "Kon Google hotels niet laden." : "Could not load hotels from Google.");
        hotelsSetNote(isDutch
          ? "Tip: vul een pickup adres in of sta locatie-toegang toe."
          : "Tip: fill a pickup address or allow location access.");
        hotelsState.fetching = false;
        updateHotelsMoreBtn();
        renderHotels([], []);
      }
    }

    function openHotelsModal() {
      if (!hotelsModal) return;
      hotelsModal.classList.add("is-open");
      hotelsModal.setAttribute("aria-hidden", "false");
      if (hotelsBtn) hotelsBtn.setAttribute("aria-expanded", "true");
      fetchHotelsAvailability();
      try { if (hotelsPollTimer) clearInterval(hotelsPollTimer); } catch (e) {}
      // Avoid hitting Places quotas unnecessarily; refresh once per minute while open
      hotelsPollTimer = setInterval(fetchHotelsAvailability, 60000);
    }

    function closeHotelsModal() {
      if (!hotelsModal) return;
      hotelsModal.classList.remove("is-open");
      hotelsModal.setAttribute("aria-hidden", "true");
      if (hotelsBtn) hotelsBtn.setAttribute("aria-expanded", "false");
      try { if (hotelsPollTimer) clearInterval(hotelsPollTimer); } catch (e) {}
      hotelsPollTimer = null;
    }

    if (hotelsBtn && hotelsModal) {
      hotelsBtn.addEventListener("click", function() {
        if (hotelsModal.classList.contains("is-open")) closeHotelsModal();
        else openHotelsModal();
      });

      hotelsModal.addEventListener("click", function(e) {
        try { if (e && e.target === hotelsModal) closeHotelsModal(); } catch (err) {}
      });

      var closeElsHotels = hotelsModal.querySelectorAll("[data-urbixx-hotels-close]");
      Array.prototype.forEach.call(closeElsHotels, function(el) {
        el.addEventListener("click", function() { closeHotelsModal(); });
      });

      document.addEventListener("keydown", function(e) {
        try {
          if (!hotelsModal.classList.contains("is-open")) return;
          if (e && (e.key === "Escape" || e.key === "Esc")) closeHotelsModal();
        } catch (err) {}
      });
    }

    if (hotelsMoreBtn) {
      hotelsMoreBtn.addEventListener("click", async function() {
        try {
          if (hotelsState.fetching) return;
          if (!hotelsState.originLatLng) return;

          hotelsState.fetching = true;
          updateHotelsMoreBtn();

          var desired = Math.min(hotelsState.max, (hotelsState.shown || 5) + 5);

          // If we already have enough results, just show more
          if (hotelsState.results.length >= desired) {
            hotelsState.shown = desired;
            await ensureHotelsDriveElements(hotelsState.shown);
            hotelsState.fetching = false;
            updateHotelsMoreBtn();
            renderHotels(hotelsState.results, hotelsState.driveElements);
            return;
          }

          // Otherwise, fetch next page(s) until we can show +5 or reach max
          if (hotelsState.pagination && hotelsState.pagination.hasNextPage && hotelsState.results.length < hotelsState.max) {
            var page = await nearbyHotelsNextPage();
            hotelsState.pagination = page.pagination || hotelsState.pagination;

            // Merge unique by place_id
            var existing = {};
            for (var i = 0; i < hotelsState.results.length; i++) {
              var pid = hotelsState.results[i] && hotelsState.results[i].place_id;
              if (pid) existing[pid] = true;
            }
            var add = (page.results || []).filter(function(r) {
              var pid2 = r && r.place_id;
              if (!pid2) return false;
              if (existing[pid2]) return false;
              existing[pid2] = true;
              return true;
            });
            hotelsState.results = hotelsState.results.concat(add).slice(0, hotelsState.max);

            hotelsState.shown = Math.min(desired, hotelsState.results.length, hotelsState.max);
            await ensureHotelsDriveElements(hotelsState.shown);
          } else {
            // No more pages available
            hotelsState.shown = Math.min(desired, hotelsState.results.length, hotelsState.max);
            await ensureHotelsDriveElements(hotelsState.shown);
          }

          hotelsState.fetching = false;
          updateHotelsMoreBtn();
          renderHotels(hotelsState.results, hotelsState.driveElements);
        } catch (e) {
          hotelsState.fetching = false;
          updateHotelsMoreBtn();
        }
      });
    }

    // Current location button (Pickup)
    var locateBtn = document.getElementById("urbixx-locate-btn");
    if (locateBtn) {
      var locateTextEl = locateBtn.querySelector(".urbixx-locate-text");
      if (locateTextEl) locateTextEl.textContent = STRINGS.locateIdle;

      locateBtn.addEventListener("click", function() {
        if (!navigator.geolocation) {
          alert(STRINGS.locateNoSupport);
          return;
        }

        if (!window.google || !google.maps) {
          alert(STRINGS.locateNoGoogle);
          return;
        }

        locateBtn.disabled = true;
        locateBtn.classList.add("is-loading");
        if (locateTextEl) locateTextEl.textContent = STRINGS.locateLoading;

        navigator.geolocation.getCurrentPosition(
          function(pos) {
            var lat = pos.coords.latitude;
            var lng = pos.coords.longitude;

            reverseGeocode(lat, lng)
              .then(function(address) {
                // Silent fill: don't pop open Places dropdown
                setFieldValue(pickupInput, address, { emitInput: false, emitChange: true, blur: true });
                scheduleDistanceUpdate();
              })
              .catch(function() {
                alert(STRINGS.locateFailed);
              })
              .finally(function() {
                locateBtn.disabled = false;
                locateBtn.classList.remove("is-loading");
                if (locateTextEl) locateTextEl.textContent = STRINGS.locateIdle;
              });
          },
          function(err) {
            var msg = err && err.code === 1 ? STRINGS.locateDenied : STRINGS.locateFailed;
            alert(msg);
            locateBtn.disabled = false;
            locateBtn.classList.remove("is-loading");
            if (locateTextEl) locateTextEl.textContent = STRINGS.locateIdle;
          },
          { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 }
        );
      });
    }

    // Quick destination tiles (fills Drop-off)
    var quickTarget = "dropoff";
    var targetToggleBtns = document.querySelectorAll("[data-urbixx-target]");

    // --- Drop-off business search (brand-only queries) ---
    var businessPanel = document.getElementById("urbixx-dropoff-business-panel");
    var businessTitleEl = document.getElementById("urbixx-dropoff-business-title");
    var businessTipEl = document.getElementById("urbixx-dropoff-business-tip");
    var businessListEl = document.getElementById("urbixx-dropoff-business-list");
    var businessMoreBtn = document.getElementById("urbixx-dropoff-business-more");
    var businessLoadingEl = document.getElementById("urbixx-dropoff-business-loading");
    var businessLoadingTextEl = document.getElementById("urbixx-dropoff-business-loading-text");

    if (businessTitleEl) businessTitleEl.textContent = STRINGS.businessTitle;
    if (businessLoadingTextEl) businessLoadingTextEl.textContent = STRINGS.businessSearching;
    if (businessMoreBtn) businessMoreBtn.textContent = STRINGS.businessLoadMore;

    var businessState = {
      token: 0,
      results: [],
      shown: 5,
      lastQuery: "",
      originSource: "pickup" // pickup|gps
    };

    function setBusinessPending(isPending) {
      if (!dropoffInput) return;
      try {
        if (isPending) dropoffInput.dataset.urbixxBusinessPending = "1";
        else delete dropoffInput.dataset.urbixxBusinessPending;
      } catch (e) {}
      updatePacVisibility();
    }

    function openBusinessPanel() {
      if (!businessPanel) return;
      businessPanel.classList.add("is-open");
      businessPanel.setAttribute("aria-hidden", "false");
      // Ensure Google Places dropdown can't overlay this panel
      updatePacVisibility();
    }

    function closeBusinessPanel() {
      if (!businessPanel) return;
      businessPanel.classList.remove("is-open");
      businessPanel.classList.remove("is-loading");
      businessPanel.setAttribute("aria-hidden", "true");
      setBusinessPending(false);
      updatePacVisibility();
      businessState.results = [];
      businessState.shown = 5;
      if (businessListEl) businessListEl.innerHTML = "";
      if (businessMoreBtn) businessMoreBtn.style.display = "none";
      if (businessTipEl) businessTipEl.textContent = "";
    }

    function setBusinessLoading(isLoading) {
      if (!businessPanel) return;
      if (isLoading) businessPanel.classList.add("is-loading");
      else businessPanel.classList.remove("is-loading");
    }

    function shortAddress(addr) {
      var s = String(addr || "").trim();
      if (!s) return "";
      var parts = s.split(",").map(function(x) { return x.trim(); }).filter(Boolean);
      if (parts.length <= 2) return s;
      return parts.slice(0, 2).join(", ");
    }

    function kmText(meters) {
      var m = typeof meters === "number" ? meters : parseFloat(meters);
      if (!isFinite(m)) return "";
      var km = m / 1000;
      var fixed = km.toFixed(1);
      if (isDutch) fixed = fixed.replace(".", ",");
      return fixed + " km";
    }

    function minutesText(seconds) {
      var s = typeof seconds === "number" ? seconds : parseFloat(seconds);
      if (!isFinite(s)) return "";
      var mins = Math.max(1, Math.round(s / 60));
      return STRINGS.approxPrefix + mins + " min";
    }

    function renderBusinessResults() {
      if (!businessListEl) return;
      businessListEl.innerHTML = "";

      var list = businessState.results || [];
      var shown = Math.min(businessState.shown || 5, list.length, 10);

      if (!list.length) {
        var li0 = document.createElement("li");
        li0.textContent = STRINGS.businessNoResults;
        li0.style.fontSize = "12px";
        li0.style.fontWeight = "700";
        li0.style.color = "rgba(0,0,0,0.60)";
        li0.style.padding = "10px 2px 2px";
        businessListEl.appendChild(li0);
        if (businessMoreBtn) businessMoreBtn.style.display = "none";
        return;
      }

      for (var i = 0; i < shown; i++) {
        (function(idx) {
          var r = list[idx];
          var li = document.createElement("li");
          var btn = document.createElement("button");
          btn.type = "button";
          btn.className = "urbixx-business-item";
          btn.setAttribute("data-idx", String(idx));
          btn.setAttribute("aria-label", "Select " + (r && r.name ? r.name : "location"));

          var top = document.createElement("div");
          top.className = "urbixx-business-item__row";

          var name = document.createElement("div");
          name.className = "urbixx-business-item__name";
          name.textContent = (r && r.name) ? r.name : "Location";

          if (r && r.hoursText) {
            var hours = document.createElement("span");
            hours.className = "urbixx-business-item__hours";
            hours.textContent = r.hoursText;
            name.appendChild(hours);
          }

          var meta = document.createElement("div");
          meta.className = "urbixx-business-item__meta";
          meta.textContent = (r && r.distanceMeters ? kmText(r.distanceMeters) : "") + (r && r.durationSeconds ? " \u2022 " + minutesText(r.durationSeconds) : "");

          var addr = document.createElement("div");
          addr.className = "urbixx-business-item__addr";
          addr.textContent = shortAddress(r && r.formatted_address ? r.formatted_address : "");

          top.appendChild(name);
          top.appendChild(meta);
          btn.appendChild(top);
          btn.appendChild(addr);

          // Use pointerdown so selection happens even if focus changes mid-click
          btn.addEventListener("pointerdown", function(e) {
            try { e.preventDefault(); } catch (e0) {}
            try {
              if (!dropoffInput) return;
              // Fill drop-off with brand + address (so user sees what they picked)
              var value = (r && r.name ? r.name + ", " : "") + (r && r.formatted_address ? r.formatted_address : "");
              setBusinessPending(false);
              closeBusinessPanel();
              // Ensure we don't show airport flight fields for this selection
              setAirportMeta(dropoffInput, null);
              setFieldValue(dropoffInput, value, { emitInput: false, emitChange: true, blur: true });
              scheduleDistanceUpdate();
            } catch (e) {}
          });

          li.appendChild(btn);
          businessListEl.appendChild(li);
        })(i);
      }

      if (businessMoreBtn) {
        var canMore = list.length > shown && shown < 10;
        businessMoreBtn.style.display = canMore ? "inline-flex" : "none";
      }
    }

    if (businessMoreBtn) {
      businessMoreBtn.addEventListener("click", function() {
        businessState.shown = Math.min(10, (businessState.shown || 5) + 5);
        renderBusinessResults();
      });
    }

    function isAddressLikeQuery(q) {
      var s = String(q || "").trim();
      if (!s) return false;
      // contains comma usually implies city/region (we don't want business mode then)
      if (s.indexOf(",") !== -1) return true;
      // digits -> often house number or postal codes
      if (/\d/.test(s)) return true;
      // NL postcode: 1234 AB
      if (/\b\d{4}\s?[A-Z]{2}\b/i.test(s)) return true;
      // DE postcode: 12345
      if (/\b\d{5}\b/.test(s)) return true;
      // address tokens
      var low = s.toLowerCase();
      var tokens = [
        "straat","laan","weg","plein","gracht","kade","dijk","singel","hof","park",
        "st.","str.","ave","avenue","road","rd","street","stree","boulevard","blvd",
        "nr","no.","house","huisnummer","postcode","zip","city","stad"
      ];
      for (var i = 0; i < tokens.length; i++) {
        if (low.indexOf(tokens[i]) !== -1) return true;
      }
      return false;
    }

    function isGenericCategoryQuery(q) {
      var s = String(q || "").trim().toLowerCase();
      if (!s) return false;
      // must be a brand-like query, not a generic category
      var generic = [
        "restaurant","restaurants",
        "cafe","caf\u00E9","cafes","caf\u00E9s",
        "bioscoop","cinema","movie","movies","theater","theatre",
        "bar","hotel","club",
        "supermarkt","supermarket",
        "winkel","shop","mall","centrum","center"
      ];
      // generic only if it is the whole query (or very close)
      for (var i = 0; i < generic.length; i++) {
        if (s === generic[i]) return true;
      }
      return false;
    }

    function isBrandBusinessQuery(q) {
      var s = String(q || "").trim();
      if (s.length < 3 || s.length > 40) return false;
      // NOTE: previous encoding corruption produced an invalid range like "Ã€-Ã¿" and crashed JS parsing.
      // We only need a quick "has letters" check (ASCII + common Latin accented range).
      if (!/[A-Za-z\u00C0-\u024F]/.test(s)) return false;
      if (isAddressLikeQuery(s)) return false;
      if (isGenericCategoryQuery(s)) return false;
      return true;
    }

    function getOriginForBusinessSearch() {
      return new Promise(function(resolve, reject) {
        try {
          var pickupVal = pickupInput ? pickupInput.value.trim() : "";
          if (pickupVal) {
            geocodeToLatLng(pickupVal)
              .then(function(latlng) {
                resolve({ latlng: latlng, source: "pickup" });
              })
              .catch(function() {
                // If pickup can't be geocoded, fallback to GPS if possible
                pickupVal = "";
                if (!navigator.geolocation) return reject(new Error("NO_GEO"));
                navigator.geolocation.getCurrentPosition(
                  function(pos) {
                    resolve({ latlng: { lat: pos.coords.latitude, lng: pos.coords.longitude }, source: "gps", shouldFillPickup: true });
                  },
                  function(err) { reject(err || new Error("GEO_DENIED")); },
                  { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 }
                );
              });
            return;
          }

          if (!navigator.geolocation) return reject(new Error("NO_GEO"));
          navigator.geolocation.getCurrentPosition(
            function(pos) {
              resolve({ latlng: { lat: pos.coords.latitude, lng: pos.coords.longitude }, source: "gps", shouldFillPickup: true });
            },
            function(err) { reject(err || new Error("GEO_DENIED")); },
            { enableHighAccuracy: true, timeout: 12000, maximumAge: 60000 }
          );
        } catch (e) {
          reject(e);
        }
      });
    }

    function ensurePickupFilledFromGps(latlng) {
      return new Promise(function(resolve) {
        try {
          if (!pickupInput) return resolve();
          if (pickupInput.value && pickupInput.value.trim()) return resolve();
          if (!latlng || typeof latlng.lat !== "number" || typeof latlng.lng !== "number") return resolve();
          reverseGeocode(latlng.lat, latlng.lng)
            .then(function(addr) {
              // Silent fill so we don't pop Places dropdown
              setFieldValue(pickupInput, addr, { emitInput: false, emitChange: true, blur: false });
            })
            .catch(function() {})
            .finally(function() { resolve(); });
        } catch (e) {
          resolve();
        }
      });
    }

    var placesDummyEl = null;
    function getPlacesService() {
      try {
        if (!window.google || !google.maps || !google.maps.places || !google.maps.places.PlacesService) return null;
        if (!placesDummyEl) placesDummyEl = document.createElement("div");
        return new google.maps.places.PlacesService(placesDummyEl);
      } catch (e) {
        return null;
      }
    }

    function normalizeText(s) {
      return String(s || "")
        .toLowerCase()
        // strip apostrophes (straight + typographic)
        .replace(/['\u2019]/g, "")
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    function getPlacesCandidatesNearby(query, originLatLng) {
      return new Promise(function(resolve, reject) {
        try {
          var svc = getPlacesService();
          if (!svc) return reject(new Error("NO_PLACES"));
          if (!originLatLng || typeof originLatLng.lat !== "number" || typeof originLatLng.lng !== "number") {
            return reject(new Error("NO_ORIGIN"));
          }

          var loc = new google.maps.LatLng(originLatLng.lat, originLatLng.lng);
          svc.nearbySearch(
            {
              location: loc,
              // key improvement: search *near origin* rather than "prominence" results
              rankBy: google.maps.places.RankBy.DISTANCE,
              keyword: query
            },
            function(results, status) {
              try {
                if (status !== google.maps.places.PlacesServiceStatus.OK || !results || !results.length) {
                  return resolve([]);
                }

                var qn = normalizeText(query);
                // Keep only results that actually look like the brand (prevents random nearby POIs)
                var filtered = results.filter(function(r) {
                  var n = normalizeText(r && r.name);
                  return !!n && (!!qn && (n.indexOf(qn) !== -1 || qn.indexOf(n) !== -1));
                });
                if (!filtered.length) filtered = results;

                resolve(
                  filtered.slice(0, 10).map(function(r) {
                    return { place_id: r.place_id, description: r.name || "" };
                  })
                );
              } catch (e2) {
                resolve([]);
              }
            }
          );
        } catch (e) {
          reject(e);
        }
      });
    }

    function getPlacesCandidatesAutocomplete(query, originLatLng) {
      return new Promise(function(resolve, reject) {
        try {
          if (!window.google || !google.maps || !google.maps.places || !google.maps.places.AutocompleteService) {
            return reject(new Error("NO_PLACES"));
          }
          var svc = new google.maps.places.AutocompleteService();
          var req = {
            input: query,
            types: ["establishment"]
          };
          // bias toward origin if possible (note: bias is not guaranteed)
          try {
            if (originLatLng && typeof originLatLng.lat === "number" && typeof originLatLng.lng === "number") {
              req.location = new google.maps.LatLng(originLatLng.lat, originLatLng.lng);
              req.radius = 50000;
            }
          } catch (e0) {}

          svc.getPlacePredictions(req, function(predictions, status) {
            if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions || !predictions.length) {
              return resolve([]);
            }
            var out = predictions.slice(0, 10).map(function(p) {
              return { place_id: p.place_id, description: p.description };
            });
            resolve(out);
          });
        } catch (e) {
          reject(e);
        }
      });
    }

    function getPlacesCandidates(query, originLatLng) {
      // Prefer true nearby results (fixes "Hilversum -> Amsterdam" issue), fallback to autocomplete
      return getPlacesCandidatesNearby(query, originLatLng).then(function(cands) {
        if (cands && cands.length) return cands;
        return getPlacesCandidatesAutocomplete(query, originLatLng);
      }).catch(function() {
        return getPlacesCandidatesAutocomplete(query, originLatLng).catch(function() { return []; });
      });
    }

    function getPlaceDetails(placeId) {
      return new Promise(function(resolve, reject) {
        try {
          var svc = getPlacesService();
          if (!svc) {
            return reject(new Error("NO_PLACES"));
          }
          svc.getDetails(
            {
              placeId: placeId,
              fields: ["place_id", "name", "formatted_address", "geometry", "types", "opening_hours", "utc_offset_minutes"]
            },
            function(place, status) {
              if (status !== google.maps.places.PlacesServiceStatus.OK || !place || !place.geometry || !place.geometry.location) {
                return reject(new Error(status || "DETAILS_FAILED"));
              }
              resolve(place);
            }
          );
        } catch (e) {
          reject(e);
        }
      });
    }

    function computeDriveMatrix(originLatLng, places) {
      return new Promise(function(resolve, reject) {
        try {
          if (!window.google || !google.maps || !google.maps.DistanceMatrixService) {
            return reject(new Error("NO_GOOGLE"));
          }
          var origin = new google.maps.LatLng(originLatLng.lat, originLatLng.lng);
          var dests = places.map(function(p) { return p.geometry.location; }).slice(0, 10);
          var svc = new google.maps.DistanceMatrixService();
          svc.getDistanceMatrix(
            {
              origins: [origin],
              destinations: dests,
              travelMode: google.maps.TravelMode.DRIVING,
              unitSystem: google.maps.UnitSystem.METRIC
            },
            function(resp, status) {
              try {
                if (status !== "OK" || !resp || !resp.rows || !resp.rows[0] || !resp.rows[0].elements) {
                  return reject(new Error(status || "MATRIX_FAILED"));
                }
                var els = resp.rows[0].elements;
                resolve(els);
              } catch (e) {
                reject(e);
              }
            }
          );
        } catch (e) {
          reject(e);
        }
      });
    }

    function formatHHMM(hhmm) {
      var t = String(hhmm || "").trim();
      if (!/^\d{4}$/.test(t)) return null;
      return t.slice(0, 2) + ":" + t.slice(2);
    }

    function getPlaceLocalNow(utcOffsetMinutes) {
      try {
        var offset = typeof utcOffsetMinutes === "number" ? utcOffsetMinutes : parseFloat(utcOffsetMinutes);
        if (!isFinite(offset)) return new Date();
        var now = new Date();
        var utcMillis = now.getTime() + now.getTimezoneOffset() * 60000;
        return new Date(utcMillis + offset * 60000);
      } catch (e) {
        return new Date();
      }
    }

    function getOpenUntilText(place) {
      try {
        if (!place || !place.opening_hours) return "";
        var oh = place.opening_hours;
        if (!oh.open_now) return STRINGS.closedNow;
        if (!oh.periods || !oh.periods.length) return "";

        var nowLocal = getPlaceLocalNow(place.utc_offset_minutes);
        var day = nowLocal.getDay(); // 0=Sun
        var nowMin = nowLocal.getHours() * 60 + nowLocal.getMinutes();
        var yday = (day + 6) % 7;
        var tday = day;
        var nday = (day + 1) % 7;

        var bestClose = null; // {dayOffsetMin:number, time:"HHMM"}

        for (var i = 0; i < oh.periods.length; i++) {
          var p = oh.periods[i];
          if (!p || !p.open) continue;
          var oDay = p.open.day;
          var oTime = p.open.time;
          var cDay = p.close && typeof p.close.day === "number" ? p.close.day : null;
          var cTime = p.close && p.close.time ? p.close.time : null;

          // 24/7 or no close info
          if (oh.open_now && (!p.close || !cTime || cDay === null)) {
            // don't early return; prefer a concrete close time if available in any period
            continue;
          }

          var oHm = String(oTime || "");
          var cHm = String(cTime || "");
          if (!/^\d{4}$/.test(oHm) || !/^\d{4}$/.test(cHm)) continue;

          var oMin = parseInt(oHm.slice(0, 2), 10) * 60 + parseInt(oHm.slice(2), 10);
          var cMin = parseInt(cHm.slice(0, 2), 10) * 60 + parseInt(cHm.slice(2), 10);

          // Compute open/close relative to "today"
          var openAbs = null;
          var closeAbs = null;

          if (oDay === tday) openAbs = oMin;
          else if (oDay === yday) openAbs = oMin - 1440;

          if (cDay === tday) closeAbs = cMin;
          else if (cDay === nday) closeAbs = cMin + 1440;

          if (openAbs === null || closeAbs === null) continue;

          // Is now within this period?
          if (nowMin >= openAbs && nowMin < closeAbs) {
            // prefer the earliest close that is still after now
            var closeTimeFmt = formatHHMM(cHm);
            if (!closeTimeFmt) continue;
            if (!bestClose || closeAbs < bestClose.closeAbs) {
              bestClose = { closeAbs: closeAbs, time: closeTimeFmt };
            }
          }
        }

        if (bestClose && bestClose.time) {
          return STRINGS.openUntil + " " + bestClose.time;
        }

        // open now but we couldn't compute a close time
        return STRINGS.open24h;
      } catch (e) {
        return "";
      }
    }

    function safeSetTip(text) {
      if (!businessTipEl) return;
      businessTipEl.textContent = String(text || "");
    }

    function runBusinessSearch(query) {
      if (!dropoffInput || !businessPanel) return;

      var token = ++businessState.token;
      businessState.lastQuery = query;
      businessState.results = [];
      businessState.shown = 5;

      openBusinessPanel();
      setBusinessPending(true);
      setBusinessLoading(true);
      if (businessListEl) businessListEl.innerHTML = "";
      if (businessMoreBtn) businessMoreBtn.style.display = "none";

      getOriginForBusinessSearch()
        .then(function(originInfo) {
          if (token !== businessState.token) return;
          businessState.originSource = originInfo && originInfo.source ? originInfo.source : "pickup";

          if (businessState.originSource === "gps") {
            safeSetTip(STRINGS.businessUsingGps + " " + STRINGS.businessTipBetter);
            return ensurePickupFilledFromGps(originInfo.latlng).then(function() { return originInfo; });
          }

          // pickup-based, still show hint for users
          safeSetTip("");
          return originInfo;
        })
        .then(function(originInfo) {
          if (token !== businessState.token) return;
          if (!originInfo || !originInfo.latlng) throw new Error("NO_ORIGIN");
          return getPlacesCandidates(query, originInfo.latlng).then(function(cands) {
            return { origin: originInfo.latlng, candidates: cands };
          });
        })
        .then(function(bundle) {
          if (token !== businessState.token) return;
          var originLatLng = bundle.origin;
          var cands = bundle.candidates || [];
          if (!cands.length) {
            businessState.results = [];
            setBusinessLoading(false);
            renderBusinessResults();
            return;
          }
          // Fetch details for up to 10 candidates
          return Promise.all(
            cands.slice(0, 10).map(function(c) {
              return getPlaceDetails(c.place_id).catch(function() { return null; });
            })
          ).then(function(details) {
            details = details.filter(Boolean);
            return { origin: originLatLng, details: details };
          });
        })
        .then(function(bundle2) {
          if (!bundle2 || token !== businessState.token) return;
          var originLatLng = bundle2.origin;
          var details = bundle2.details || [];
          if (!details.length) {
            businessState.results = [];
            setBusinessLoading(false);
            renderBusinessResults();
            return;
          }
          return computeDriveMatrix(originLatLng, details).then(function(elements) {
            return { details: details, elements: elements };
          });
        })
        .then(function(bundle3) {
          if (!bundle3 || token !== businessState.token) return;
          var details = bundle3.details || [];
          var elements = bundle3.elements || [];

          var merged = [];
          for (var i = 0; i < details.length; i++) {
            var p = details[i];
            var el = elements[i];
            if (!p || !el || el.status !== "OK" || !el.distance || !el.duration) continue;
            merged.push({
              place_id: p.place_id,
              name: p.name || "",
              formatted_address: p.formatted_address || "",
              hoursText: getOpenUntilText(p),
              distanceMeters: el.distance.value,
              durationSeconds: el.duration.value
            });
          }

          merged.sort(function(a, b) {
            return (a.distanceMeters || 0) - (b.distanceMeters || 0);
          });

          businessState.results = merged.slice(0, 10);
          setBusinessLoading(false);
          renderBusinessResults();
        })
        .catch(function() {
          if (token !== businessState.token) return;
          setBusinessLoading(false);
          // If we can't determine origin, tell user to set pickup
          safeSetTip(STRINGS.businessNeedPickupOrGps);
          businessState.results = [];
          renderBusinessResults();
        });
    }

    var businessDebounceTimer = null;
    function scheduleBusinessCheck() {
      if (!dropoffInput) return;
      var q = (dropoffInput.value || "").trim();

      // Only show panel for strict brand-only queries
      if (!isBrandBusinessQuery(q)) {
        closeBusinessPanel();
        return;
      }

      openBusinessPanel();
      setBusinessPending(true);
      if (businessTipEl) {
        // show pickup tip only if pickup is empty
        var pickupVal = pickupInput ? pickupInput.value.trim() : "";
        safeSetTip(pickupVal ? "" : STRINGS.businessTipBetter);
      }

      if (businessDebounceTimer) window.clearTimeout(businessDebounceTimer);
      businessDebounceTimer = window.setTimeout(function() {
        // Avoid re-running same query repeatedly
        if (q && q === businessState.lastQuery && businessState.results && businessState.results.length) return;
        runBusinessSearch(q);
      }, 320);
    }

    if (dropoffInput) {
      dropoffInput.addEventListener("input", function() {
        scheduleBusinessCheck();
      });
      dropoffInput.addEventListener("change", function() {
        // If user selects a real address, hide business panel
        var q = (dropoffInput.value || "").trim();
        if (!isBrandBusinessQuery(q)) closeBusinessPanel();
      });
      dropoffInput.addEventListener("blur", function() {
        // Keep panel open briefly on blur so click selection works
        setTimeout(function() {
          try {
            var active = document.activeElement;
            if (businessPanel && businessPanel.contains(active)) return;
            // if user didn't select anything and query changed to address-like, close
            var q = (dropoffInput.value || "").trim();
            if (!isBrandBusinessQuery(q)) closeBusinessPanel();
          } catch (e) {}
        }, 140);
      });
    }

    // Help modal (premium popup)
    var helpBtn = document.getElementById("urbixx-quick-help-btn");
    var helpModal = document.getElementById("urbixx-quick-help-modal");
    var helpText = document.getElementById("urbixx-help-text");
    var helpTitle = document.getElementById("urbixx-help-title");

    function openHelp() {
      if (!helpModal) return;
      helpModal.classList.add("is-open");
      helpModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      if (helpBtn) helpBtn.setAttribute("aria-expanded", "true");
    }

    function closeHelp() {
      if (!helpModal) return;
      helpModal.classList.remove("is-open");
      helpModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      if (helpBtn) helpBtn.setAttribute("aria-expanded", "false");
    }

    if (helpTitle) {
      helpTitle.textContent = isDutch ? "Hoe snelle locaties werken" : "How quick locations work";
    }
    if (helpText) {
      helpText.textContent = isDutch
        ? "Gebruik de Pickup / Drop-off schakelaar om te kiezen welk veld je wilt vullen. Tik daarna op een tile of kies een airport om het gekozen veld direct in te vullen."
        : "Use the Pickup / Drop-off toggle to choose which field you want to fill. Then tap a tile or select an airport to instantly populate the chosen field.";
    }

    if (helpBtn && helpModal) {
      helpBtn.addEventListener("click", function() {
        if (helpModal.classList.contains("is-open")) closeHelp();
        else openHelp();
      });

      var closeEls = helpModal.querySelectorAll("[data-urbixx-help-close]");
      Array.prototype.forEach.call(closeEls, function(el) {
        el.addEventListener("click", closeHelp);
      });

      document.addEventListener("keydown", function(e) {
        if (e.key === "Escape") closeHelp();
      });
    }

    function getTargetInput() {
      return quickTarget === "pickup" ? pickupInput : dropoffInput;
    }

    function setActiveTarget(target) {
      quickTarget = target === "pickup" ? "pickup" : "dropoff";
      if (targetToggleBtns && targetToggleBtns.length) {
        Array.prototype.forEach.call(targetToggleBtns, function(b) {
          var t = b.getAttribute("data-urbixx-target");
          if (t === quickTarget) b.classList.add("is-active");
          else b.classList.remove("is-active");
        });
      }
    }

    if (targetToggleBtns && targetToggleBtns.length) {
      Array.prototype.forEach.call(targetToggleBtns, function(b) {
        b.addEventListener("click", function() {
          var t = b.getAttribute("data-urbixx-target");
          setActiveTarget(t);
        });
      });
    }

    // --- Mobile hover dock for the Pickup/Drop-off toggle (Step 1 only) ---
    (function setupMobileQuickTargetDock() {
      var sentinel = document.getElementById("urbixx-target-toggle-sentinel");
      var dock = document.getElementById("urbixx-mobile-target-dock");
      var dockSlot = document.getElementById("urbixx-mobile-target-dock-toggle");
      var tipEl = document.getElementById("urbixx-mobile-target-tip");
      var tipClose = document.getElementById("urbixx-mobile-target-tip-close");
      var toggleWrap = document.querySelector("#urbixx-step-1 .urbixx-top-quick__bar .urbixx-target-toggle");

      if (!sentinel || !dock || !dockSlot || !toggleWrap) return;

      var dismissedKey = "urbixx_quick_target_tip_dismissed_v1";
      var isDocked = false;
      var headerOffsetPx = 44; // trigger dock slightly earlier (accounts for mobile header height)

      function isMobile() {
        try {
          return !!(window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
        } catch (e) {
          return (window.innerWidth || 9999) <= 768;
        }
      }

      function isStep1Visible() {
        try { return !!(step1 && step1.style.display !== "none"); } catch (e) { return true; }
      }

      function showDock() {
        try {
          dock.classList.add("is-open");
          dock.setAttribute("aria-hidden", "false");
        } catch (e) {}
      }

      function hideDock() {
        try {
          dock.classList.remove("is-open");
          dock.setAttribute("aria-hidden", "true");
        } catch (e) {}
      }

      function showTipOnce() {
        if (!tipEl) return;
        try {
          if (window.localStorage && localStorage.getItem(dismissedKey) === "1") return;
        } catch (e) {}

        try { tipEl.style.display = "flex"; } catch (e2) {}
        requestAnimationFrame(function() {
          try { tipEl.classList.add("is-open"); } catch (e3) {}
        });
      }

      function hideTipPersist() {
        if (!tipEl) return;
        try { tipEl.classList.remove("is-open"); } catch (e) {}
        setTimeout(function() {
          try { tipEl.style.display = "none"; } catch (e2) {}
        }, 220);
        try { if (window.localStorage) localStorage.setItem(dismissedKey, "1"); } catch (e3) {}
      }

      if (tipClose) {
        tipClose.addEventListener("click", function(e) {
          try { if (e) e.preventDefault(); } catch (e0) {}
          hideTipPersist();
        });
      }

      function flipAnimate(fromRect, toRect) {
        try {
          if (!fromRect || !toRect) return;
          var dx = (fromRect.left - toRect.left);
          var dy = (fromRect.top - toRect.top);
          if (!isFinite(dx) || !isFinite(dy)) return;

          toggleWrap.style.transition = "none";
          toggleWrap.style.transform = "translate3d(" + dx + "px," + dy + "px,0)";
          toggleWrap.style.willChange = "transform";
          // force reflow
          toggleWrap.getBoundingClientRect();

          requestAnimationFrame(function() {
            toggleWrap.style.transition = "transform 420ms cubic-bezier(0.2, 0.9, 0.2, 1)";
            toggleWrap.style.transform = "translate3d(0,0,0)";
            setTimeout(function() {
              try {
                toggleWrap.style.transition = "";
                toggleWrap.style.transform = "";
                toggleWrap.style.willChange = "";
              } catch (e2) {}
            }, 480);
          });
        } catch (e) {}
      }

      function undockToOriginal() {
        try {
          if (!sentinel.parentNode) return;
          sentinel.parentNode.insertBefore(toggleWrap, sentinel.nextSibling);
        } catch (e) {}
      }

      function setDocked(next, reason) {
        var want = !!next;
        if (!isMobile() || !isStep1Visible()) want = false;
        if (want === isDocked) return;
        isDocked = want;

        var first = null;
        var last = null;
        try { first = toggleWrap.getBoundingClientRect(); } catch (e0) {}

        if (want) {
          showDock();
          try { dockSlot.appendChild(toggleWrap); } catch (e1) {}
        } else {
          undockToOriginal();
          hideDock();
        }

        try { last = toggleWrap.getBoundingClientRect(); } catch (e2) {}
        flipAnimate(first, last);

        if (want) showTipOnce();
      }

      function refreshFromSentinel() {
        try {
          if (!isMobile() || !isStep1Visible()) return setDocked(false, "disabled");
          var r = sentinel.getBoundingClientRect();
          var topCut = headerOffsetPx || 0;
          var inView = r.bottom > topCut && r.top < (window.innerHeight || 0);
          setDocked(!inView, "scroll");
        } catch (e) {}
      }

      // IntersectionObserver drives the behaviour (smooth + efficient)
      if ("IntersectionObserver" in window) {
        try {
          var io = new IntersectionObserver(function(entries) {
            try {
              if (!entries || !entries.length) return;
              var entry = entries[0];
              if (!isMobile() || !isStep1Visible()) return setDocked(false, "disabled");
              setDocked(!entry.isIntersecting, "io");
            } catch (e) {}
          }, { root: null, threshold: 0.05, rootMargin: "-" + String(headerOffsetPx || 0) + "px 0px 0px 0px" });
          io.observe(sentinel);
        } catch (e0) {
          window.addEventListener("scroll", refreshFromSentinel, { passive: true });
          window.addEventListener("resize", refreshFromSentinel);
        }
      } else {
        window.addEventListener("scroll", refreshFromSentinel, { passive: true });
        window.addEventListener("resize", refreshFromSentinel);
      }

      // Re-evaluate on resize (orientation changes)
      try {
        var mql = window.matchMedia && window.matchMedia("(max-width: 768px)");
        if (mql && mql.addEventListener) {
          mql.addEventListener("change", function() {
            setDocked(false, "mq");
            setTimeout(refreshFromSentinel, 0);
          });
        }
      } catch (eMq) {}

      // Expose minimal hooks for step transitions
      try {
        window.__urbixxQuickToggleDockHide = function() { setDocked(false, "force_hide"); };
        window.__urbixxQuickToggleDockUpdate = function() { setTimeout(refreshFromSentinel, 0); };
      } catch (eExpose) {}

      // Prime
      setTimeout(refreshFromSentinel, 0);
    })();

    var quickTiles = document.querySelectorAll("[data-urbixx-quick-destination]");
    if (quickTiles && quickTiles.length) {
      Array.prototype.forEach.call(quickTiles, function(btn) {
        btn.addEventListener("click", function() {
          var q = btn.getAttribute("data-query") || "";
          if (!q) return;
          var targetInput = getTargetInput();
          if (!targetInput) return;
          var token = markAutofill(targetInput, q);
          // Silent fill: don't trigger Places dropdown; change event is enough for our flow
          setFieldValue(targetInput, q, { emitInput: false, emitChange: true, blur: true });
          geocodeAddress(q)
            .then(function(formatted) {
              if (canApplyAutofill(targetInput, token, q)) {
                setFieldValue(targetInput, formatted, { emitInput: false, emitChange: true, blur: true });
              }
            })
            .catch(function() {})
            .finally(function() {
              scheduleDistanceUpdate();
            });
        });
      });
    }

    // Locations dropdown + filter (airports + stations)
    var airportSelect = document.getElementById("urbixx-airport-select");
    var airportFilterBtns = document.querySelectorAll("[data-urbixx-location-tab]");

    // Curated: known commercial airports only
    var AIRPORTS = {
      NL: [
        { code: "AMS", name: "Amsterdam Schiphol Airport", query: "Amsterdam Airport Schiphol, Schiphol, Netherlands" },
        { code: "EIN", name: "Eindhoven Airport", query: "Eindhoven Airport, Eindhoven, Netherlands" },
        { code: "RTM", name: "Rotterdam The Hague Airport", query: "Rotterdam The Hague Airport, Rotterdam, Netherlands" },
        { code: "MST", name: "Maastricht Aachen Airport", query: "Maastricht Aachen Airport, Maastricht, Netherlands" }
      ],
      DE: [
        { code: "FRA", name: "Frankfurt Airport", query: "Frankfurt Airport, Frankfurt am Main, Germany" },
        { code: "MUC", name: "Munich Airport", query: "Munich Airport, Munich, Germany" },
        { code: "BER", name: "Berlin Brandenburg Airport", query: "Berlin Brandenburg Airport, Berlin, Germany" },
        { code: "DUS", name: "D\u00FCsseldorf Airport", query: "D\u00FCsseldorf Airport, D\u00FCsseldorf, Germany" },
        { code: "HAM", name: "Hamburg Airport", query: "Hamburg Airport, Hamburg, Germany" },
        { code: "CGN", name: "Cologne Bonn Airport", query: "Cologne Bonn Airport, Cologne, Germany" }
      ],
      BE: [
        { code: "BRU", name: "Brussels Airport", query: "Brussels Airport, Zaventem, Belgium" },
        { code: "CRL", name: "Brussels South Charleroi Airport", query: "Brussels South Charleroi Airport, Charleroi, Belgium" },
        { code: "ANR", name: "Antwerp International Airport", query: "Antwerp International Airport, Antwerp, Belgium" },
        { code: "LGG", name: "Li\u00E8ge Airport", query: "Li\u00E8ge Airport, Li\u00E8ge, Belgium" }
      ]
    };

    // Curated: popular train stations (NL) + DE stations near NL border
    var STATIONS = {
      ST_NL: [
        { name: "Amsterdam Centraal", query: "Amsterdam Centraal Station, Amsterdam, Netherlands" },
        { name: "Utrecht Centraal", query: "Utrecht Centraal Station, Utrecht, Netherlands" },
        { name: "Rotterdam Centraal", query: "Rotterdam Centraal Station, Rotterdam, Netherlands" },
        { name: "Den Haag Centraal", query: "Den Haag Centraal Station, The Hague, Netherlands" },
        { name: "Eindhoven Centraal", query: "Eindhoven Centraal Station, Eindhoven, Netherlands" },
        { name: "Arnhem Centraal", query: "Arnhem Centraal Station, Arnhem, Netherlands" },
        { name: "Nijmegen", query: "Nijmegen Station, Nijmegen, Netherlands" },
        { name: "Zwolle", query: "Zwolle Station, Zwolle, Netherlands" },
        { name: "Haarlem", query: "Haarlem Station, Haarlem, Netherlands" },
        { name: "Hilversum", query: "Station Hilversum, Hilversum, Netherlands" }
      ],
      ST_DE: [
        { name: "Aachen Hbf", query: "Aachen Hauptbahnhof, Aachen, Germany" },
        { name: "D\u00FCsseldorf Hbf", query: "D\u00FCsseldorf Hauptbahnhof, D\u00FCsseldorf, Germany" },
        { name: "K\u00F6ln Hbf", query: "K\u00F6ln Hauptbahnhof, Cologne, Germany" },
        { name: "Duisburg Hbf", query: "Duisburg Hauptbahnhof, Duisburg, Germany" },
        { name: "Essen Hbf", query: "Essen Hauptbahnhof, Essen, Germany" },
        { name: "Dortmund Hbf", query: "Dortmund Hauptbahnhof, Dortmund, Germany" },
        { name: "M\u00FCnster (Westf) Hbf", query: "M\u00FCnster (Westf) Hauptbahnhof, M\u00FCnster, Germany" },
        { name: "Bonn Hbf", query: "Bonn Hauptbahnhof, Bonn, Germany" },
        { name: "M\u00F6nchengladbach Hbf", query: "M\u00F6nchengladbach Hauptbahnhof, M\u00F6nchengladbach, Germany" },
        { name: "Oberhausen Hbf", query: "Oberhausen Hauptbahnhof, Oberhausen, Germany" }
      ]
    };

    // Flight number UI (only shown when pickup/drop-off is an airport)
    var flightPickupWrap = document.getElementById("urbixx-flight-pickup");
    var flightDropoffWrap = document.getElementById("urbixx-flight-dropoff");
    var flightPickupLabelEl = document.getElementById("urbixx-flight-label-pickup");
    var flightDropoffLabelEl = document.getElementById("urbixx-flight-label-dropoff");
    var flightPickupHintEl = document.getElementById("urbixx-flight-hint-pickup");
    var flightDropoffHintEl = document.getElementById("urbixx-flight-hint-dropoff");
    var flightPickupInputEl = document.getElementById("urbixx-flight-number-pickup");
    var flightDropoffInputEl = document.getElementById("urbixx-flight-number-dropoff");
    // Inline flight info panel (under the pickup flight number field)
    var flightSlideoutEl = document.getElementById("urbixx-flight-inline");
    var flightSlideoutBodyEl = document.getElementById("urbixx-flight-inline-body");
    var flightAdviceEl = document.getElementById("urbixx-flight-time-advice");

    if (flightPickupLabelEl) flightPickupLabelEl.textContent = STRINGS.flightLabelPickup;
    if (flightDropoffLabelEl) flightDropoffLabelEl.textContent = STRINGS.flightLabelDropoff;
    if (flightPickupHintEl) flightPickupHintEl.textContent = STRINGS.flightPromptPickup;
    if (flightDropoffHintEl) flightDropoffHintEl.textContent = STRINGS.flightPromptDropoff;

    // --- Flight info slide-out (Schiphol) ---
    // Enable debug logs by running in console:
    //   window.__URBIXX_FLIGHT_DEBUG = true
    // Or by adding ?debugFlight=1 to the URL.
    try {
      if (typeof window !== "undefined" && window.location && String(window.location.search || "").indexOf("debugFlight=1") !== -1) {
        window.__URBIXX_FLIGHT_DEBUG = true;
      }
    } catch (e) {}

    function flightDebug() {
      try {
        if (!window.__URBIXX_FLIGHT_DEBUG) return;
        var args = Array.prototype.slice.call(arguments);
        args.unshift("[UrbixxFlight]");
        // eslint-disable-next-line no-console
        console.log.apply(console, args);
      } catch (e) {}
    }

    var flightInfoState = {
      status: "idle", // idle|loading|success|error|not_found
      dto: null,
      lastLookupKey: "",
      lastSuccessKey: "",
      userTouchedPickupTime: false,
      pendingAdvisedTime: null,
      _settingPickupTime: false
    };

    function ensureFlightSlideoutDom() {
      if (flightSlideoutEl && flightSlideoutBodyEl) return;

      // Inline panel exists under the pickup flight field; if missing, inject it there.
      var existing = document.getElementById("urbixx-flight-inline");
      if (!existing) {
        try {
          if (!flightPickupWrap) return;
          existing = document.createElement("div");
          existing.id = "urbixx-flight-inline";
          existing.className = "urbixx-flight-inline";
          existing.setAttribute("aria-hidden", "true");

          var inner = document.createElement("div");
          inner.className = "urbixx-flight-inline__inner";
          inner.id = "urbixx-flight-inline-body";
          inner.setAttribute("aria-live", "polite");

          existing.appendChild(inner);
          flightPickupWrap.appendChild(existing);
        } catch (e) {
          return;
        }
      }

      flightSlideoutEl = existing;
      flightSlideoutBodyEl = document.getElementById("urbixx-flight-inline-body");
    }

    function ensureFlightAdviceDom() {
      if (flightAdviceEl) return;
      flightAdviceEl = document.getElementById("urbixx-flight-time-advice");
      if (flightAdviceEl) return;
      if (!pickupTimeEl) return;
      try {
        var field = pickupTimeEl.closest(".urbixx-field");
        if (!field) return;
        var div = document.createElement("div");
        div.id = "urbixx-flight-time-advice";
        div.className = "urbixx-flight-advice";
        div.setAttribute("aria-live", "polite");
        div.style.display = "none";
        field.appendChild(div);
        flightAdviceEl = div;
      } catch (e) {}
    }

    function isPickupAirportActive() {
      try {
        if (!flightPickupWrap) return false;
        return flightPickupWrap.getAttribute("aria-hidden") === "false" || flightPickupWrap.classList.contains("is-visible");
      } catch (e) {
        return false;
      }
    }

    function isSchipholAirportMatch(airportMatch) {
      if (!airportMatch) return false;
      var code = String(airportMatch.code || "").toUpperCase();
      var name = String(airportMatch.name || "").toLowerCase();
      var query = String(airportMatch.query || "").toLowerCase();
      return code === "AMS" || name.indexOf("schiphol") !== -1 || query.indexOf("schiphol") !== -1;
    }

    function openFlightSlideout() {
      ensureFlightSlideoutDom();
      if (!flightSlideoutEl) return;
      flightSlideoutEl.classList.add("is-open");
      flightSlideoutEl.setAttribute("aria-hidden", "false");
    }

    function closeFlightSlideout() {
      ensureFlightSlideoutDom();
      if (!flightSlideoutEl) return;
      flightSlideoutEl.classList.remove("is-open");
      flightSlideoutEl.setAttribute("aria-hidden", "true");
      if (flightSlideoutBodyEl) flightSlideoutBodyEl.innerHTML = "";
    }

    function escapeHtml(s) {
      var div = document.createElement("div");
      div.textContent = String(s || "");
      return div.innerHTML;
    }

    function renderFlightSkeleton() {
      ensureFlightSlideoutDom();
      if (!flightSlideoutBodyEl) return;
      flightSlideoutBodyEl.innerHTML =
        '<div class="urbixx-flight-skel" style="margin-bottom:12px; height:120px;"></div>' +
        '<div class="urbixx-flight-skel" style="height:140px;"></div>';
    }

    function renderFlightError(message, canRetry) {
      ensureFlightSlideoutDom();
      if (!flightSlideoutBodyEl) return;
      var retryBtn = canRetry ? '<button type="button" class="urbixx-flight-advice__btn" id="urbixx-flight-retry-btn">Retry</button>' : '';
      flightSlideoutBodyEl.innerHTML =
        '<div class="urbixx-flight-card">' +
        '  <div class="urbixx-flight-row"><div class="urbixx-flight-label">Flight lookup</div><div class="urbixx-flight-value">Couldn\'t load flight data</div></div>' +
        '  <div style="margin-top:10px; color:rgba(255,255,255,0.72); font-size:13px; line-height:1.5;">' + escapeHtml(message) + '</div>' +
        (retryBtn ? '<div style="margin-top:14px; display:flex; justify-content:flex-end;">' + retryBtn + '</div>' : '') +
        '</div>';

      if (canRetry) {
        var btn = document.getElementById("urbixx-flight-retry-btn");
        if (btn) {
          btn.addEventListener("click", function () {
            if (flightPickupInputEl) flightPickupInputEl.dispatchEvent(new Event("input"));
          });
        }
      }
    }

    function renderFlightNotFound(flightNumber, dateYmd) {
      ensureFlightSlideoutDom();
      if (!flightSlideoutBodyEl) return;
      flightSlideoutBodyEl.innerHTML =
        '<div class="urbixx-flight-card">' +
        '  <div class="urbixx-flight-row"><div class="urbixx-flight-label">Flight</div><div class="urbixx-flight-value">' + escapeHtml(flightNumber) + '</div></div>' +
        '  <div style="margin-top:10px; color:rgba(255,255,255,0.72); font-size:13px; line-height:1.5;">No Schiphol flight found for the selected date (' + escapeHtml(dateYmd || "") + '). You can still continue with manual pickup time.</div>' +
        '</div>';
    }

    // GSAP Airplane Landing Animation
    // Based on JSON timeline with easeOutCubic landing, 2s wait, easeInCubic takeoff
    var airplaneTimeline = null;
    function initAirplaneGsapAnimation() {
      // Check if GSAP is loaded
      if (typeof gsap === "undefined") {
        console.warn("GSAP not loaded, skipping airplane animation");
        return;
      }

      var airplaneImg = document.querySelector(".urbixx-flight-plane__img");
      if (!airplaneImg) return;

      // Kill any existing timeline to prevent duplicates
      if (airplaneTimeline) {
        airplaneTimeline.kill();
      }

      // JSON Timeline from prototype (normalized for container space)
      var timeline = [
        { time: 0.0,  x: -30, y: -20, rotation: -32, opacity: 0.0, ease: "power3.out" },
        { time: 2.5,  x: 0,   y: 8,   rotation: -4,  opacity: 0.96, ease: "none" },
        { time: 4.5,  x: 0,   y: 8,   rotation: -4,  opacity: 0.96, ease: "power3.in" },
        { time: 7.0,  x: 40,  y: -16, rotation: -24, opacity: 0.0, ease: "none" }
      ];

      // Create infinite looping timeline
      airplaneTimeline = gsap.timeline({ repeat: -1, repeatDelay: 0 });

      // Set initial position (frame 0)
      gsap.set(airplaneImg, {
        x: timeline[0].x,
        y: timeline[0].y,
        rotation: timeline[0].rotation,
        opacity: timeline[0].opacity
      });

      // Build animation tweens
      for (var i = 0; i < timeline.length - 1; i++) {
        var current = timeline[i];
        var next = timeline[i + 1];
        var duration = next.time - current.time;

        if (current.ease === "none") {
          // Wait period (no movement)
          airplaneTimeline.to(airplaneImg, { duration: duration, ease: "none" });
        } else {
          // Animate to next position
          airplaneTimeline.to(airplaneImg, {
            duration: duration,
            x: next.x,
            y: next.y,
            rotation: next.rotation,
            opacity: next.opacity,
            ease: current.ease
          });
        }
      }
    }

    function renderFlightSuccess(dto, eta, sta, statusText) {
      ensureFlightSlideoutDom();
      if (!flightSlideoutBodyEl) return;
      var airline = dto && dto.airline ? String(dto.airline) : "-";
      var flightNumber = dto && dto.flightNumber ? String(dto.flightNumber) : "";
      var etaShow = eta || "-";
      var staShow = sta || "-";
      var statusShow = statusText || (dto && dto.status ? String(dto.status) : "-");
      var iconUrl = "";
      try {
        iconUrl = (window.URBIXX_BOOKING_CONFIG && window.URBIXX_BOOKING_CONFIG.flightMiniIconUrl)
          ? String(window.URBIXX_BOOKING_CONFIG.flightMiniIconUrl)
          : "";
      } catch (e0) {}

      flightSlideoutBodyEl.innerHTML =
        '<div class="urbixx-flight-card">' +
        '  <div style="display:flex; align-items:center; justify-content:space-between; gap:10px; margin-bottom:12px;">' +
        '    <div class="urbixx-flight-airline-chip"><span style="opacity:.9">✈</span><span>' + escapeHtml(airline) + '</span></div>' +
        '    <div style="font-weight:900; letter-spacing:-0.02em;">' + escapeHtml(flightNumber) + '</div>' +
        '  </div>' +
        '  <div class="urbixx-flight-eta">' +
        '    <div class="urbixx-flight-plane" aria-hidden="true">' +
        '      <img class="urbixx-flight-plane__img" alt="" loading="lazy" src="' + escapeHtml(iconUrl) + '">' +
        '    </div>' +
        '    <div>' +
        '      <div class="urbixx-flight-label">Expected arrival (ETA)</div>' +
        '      <div class="urbixx-flight-eta-time">' + escapeHtml(etaShow) + '</div>' +
        '      <div class="urbixx-flight-eta-sub">Scheduled arrival (STA): ' + escapeHtml(staShow) + '</div>' +
        '    </div>' +
        '  </div>' +
        '  <div class="urbixx-flight-row"><div class="urbixx-flight-label">Status</div><div class="urbixx-flight-value">' + escapeHtml(statusShow) + '</div></div>' +
        '  <div class="urbixx-flight-row"><div class="urbixx-flight-label">Last updated</div><div class="urbixx-flight-value">' + escapeHtml(dto.lastUpdated || "") + '</div></div>' +
        '</div>';

      // Initialize GSAP airplane animation after DOM is rendered
      setTimeout(function() {
        initAirplaneGsapAnimation();
      }, 50);
    }

    function setAdviceUI(advisedTime, applied) {
      ensureFlightAdviceDom();
      if (!flightAdviceEl) return;
      if (!advisedTime) {
        flightAdviceEl.style.display = "none";
        flightAdviceEl.innerHTML = "";
        return;
      }
      if (!isPickupAirportActive()) {
        flightAdviceEl.style.display = "none";
        flightAdviceEl.innerHTML = "";
        return;
      }

      var txt = applied
        ? "Advice: pickup time was automatically set to 30 minutes after the expected landing time."
        : "Advice: recommended pickup time is 30 minutes after the expected landing time.";
      var btn = (!applied && flightInfoState.userTouchedPickupTime)
        ? '<button type="button" class="urbixx-flight-advice__btn" id="urbixx-apply-flight-time">Apply</button>'
        : '';
      flightAdviceEl.innerHTML = '<div class="urbixx-flight-advice__text">' + escapeHtml(txt) + (advisedTime ? (' <strong>' + escapeHtml(advisedTime) + '</strong>') : '') + '</div>' + btn;
      flightAdviceEl.style.display = "flex";

      if (btn) {
        var applyBtn = document.getElementById("urbixx-apply-flight-time");
        if (applyBtn) {
          applyBtn.addEventListener("click", function () {
            flightInfoState.userTouchedPickupTime = false;
            tryApplyAdvisedPickupTime(advisedTime, true);
          });
        }
      }
    }

    function tryApplyAdvisedPickupTime(advisedTime, force) {
      if (!pickupTimeEl) return;
      if (!advisedTime) return;
      // Requirement: if drop-off not filled, wait to apply/show until it is filled.
      var dropoffFilled = !!((dropoffInput && dropoffInput.value && String(dropoffInput.value).trim()) || "");
      if (!dropoffFilled) {
        flightInfoState.pendingAdvisedTime = advisedTime;
        flightDebug("time_advice_pending_waiting_for_dropoff", { advisedTime: advisedTime });
        return;
      }
      if (!isPickupAirportActive()) return;
      if (!force && flightInfoState.userTouchedPickupTime) {
        setAdviceUI(advisedTime, false);
        return;
      }
      // Apply time
      flightInfoState._settingPickupTime = true;
      try {
        pickupTimeEl.value = advisedTime;
        pickupTimeEl.dispatchEvent(new Event("change", { bubbles: true }));
      } catch (e) {
        // no-op
      } finally {
        flightInfoState._settingPickupTime = false;
      }
      setAdviceUI(advisedTime, true);
    }

    // Mark manual override of pickup time
    if (pickupTimeEl) {
      pickupTimeEl.addEventListener("input", function () {
        if (flightInfoState._settingPickupTime) return;
        flightInfoState.userTouchedPickupTime = true;
        flightDebug("pickup_time_user_touched");
      });
      pickupTimeEl.addEventListener("change", function () {
        if (flightInfoState._settingPickupTime) return;
        flightInfoState.userTouchedPickupTime = true;
        flightDebug("pickup_time_user_touched");
      });
    }

    // Apply pending advice once drop-off is filled
    if (dropoffInput) {
      var onDropoffFilledMaybeApply = function () {
        var filled = !!(String(dropoffInput.value || "").trim());
        if (filled && flightInfoState.pendingAdvisedTime) {
          var t = flightInfoState.pendingAdvisedTime;
          flightInfoState.pendingAdvisedTime = null;
          flightDebug("dropoff_filled_apply_pending_time_advice", { advisedTime: t });
          tryApplyAdvisedPickupTime(t, false);
        }
      };
      dropoffInput.addEventListener("input", onDropoffFilledMaybeApply);
      dropoffInput.addEventListener("change", onDropoffFilledMaybeApply);
    }

    // Inline panel: no global close handlers (no backdrop / ESC).
    ensureFlightSlideoutDom();

    function getYmdForPickup() {
      var el = document.getElementById("pickup-date");
      var v = el && el.value ? String(el.value).trim() : "";
      if (/^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
      var d = new Date();
      var y = d.getFullYear();
      var m = String(d.getMonth() + 1).padStart(2, "0");
      var day = String(d.getDate()).padStart(2, "0");
      return y + "-" + m + "-" + day;
    }

    function computeAdvisedFromDto(dto) {
      if (!dto) return null;
      var date = dto.scheduleDate || getYmdForPickup();
      var eta = dto.actualTime || dto.estimatedTime || null;
      if (!eta) return null;
      var utils = (window.URBIXX_FLIGHT_UTILS || {});
      if (typeof utils.toAdvisedPickupTime === "function") {
        return utils.toAdvisedPickupTime(date, String(eta).slice(0,5), 30);
      }
      return null;
    }

    var debouncedPickupFlightLookup = null;
    function ensureDebouncer() {
      if (debouncedPickupFlightLookup) return;
      var utils = (window.URBIXX_FLIGHT_UTILS || {});
      var make = utils.createDebouncer;
      if (typeof make !== "function") {
        // fallback
        make = function (ms, fn) {
          var t = null;
          return function () {
            var args = arguments;
            if (t) clearTimeout(t);
            t = setTimeout(function () { fn.apply(null, args); }, ms);
          };
        };
      }
      debouncedPickupFlightLookup = make(500, function (normVal, dateYmd, reason) {
        lookupSchipholArrival(normVal, dateYmd, reason);
      });
    }

    function getNormalizedPickupFlightNumber(rawVal) {
      var utils = (window.URBIXX_FLIGHT_UTILS || {});
      return (typeof utils.normalizeFlightNumber === "function")
        ? utils.normalizeFlightNumber(rawVal)
        : String(rawVal || "").trim().toUpperCase().replace(/\s+/g, "");
    }

    function isValidPickupFlightNumber(normVal) {
      var utils = (window.URBIXX_FLIGHT_UTILS || {});
      return (typeof utils.isValidFlightNumber === "function")
        ? utils.isValidFlightNumber(normVal)
        : (String(normVal || "").trim().length >= 3);
    }

    function schedulePickupFlightLookup(reason) {
      ensureDebouncer();
      var pickupAirport = getAirportForInput(pickupInput);
      var isSchiphol = isSchipholAirportMatch(pickupAirport);
      var raw = flightPickupInputEl ? flightPickupInputEl.value : "";
      var norm = getNormalizedPickupFlightNumber(raw);
      var valid = isValidPickupFlightNumber(norm);
      var date = getYmdForPickup();

      var canLookup = !!(isSchiphol && valid);
      flightDebug("maybe_lookup", {
        reason: reason || "",
        canLookup: canLookup,
        pickupAirport: pickupAirport ? (pickupAirport.code || pickupAirport.name) : null,
        flightNumber: norm,
        date: date
      });

      if (!canLookup) {
        // If not Schiphol or flight number invalid/cleared, hide flight UX.
        // (Keeps slide-out open for normal edits, but closes when lookup is no longer applicable.)
        if (!isSchiphol || !norm) {
          try { closeFlightSlideout(); } catch (e1) {}
          try { setAdviceUI(null, false); } catch (e2) {}
        }
        return;
      }

      // Prevent repeat calls when nothing changed (order-independent trigger).
      var key = norm + "|" + date + "|arrival";
      if (key === flightInfoState.lastLookupKey && (flightInfoState.status === "loading" || flightInfoState.status === "success")) {
        return;
      }
      flightInfoState.lastLookupKey = key;
      debouncedPickupFlightLookup(norm, date, reason || "");
    }

    async function lookupSchipholArrival(normVal, dateYmd, reason) {
      try {
        // The slide-out is driven by lookup success; the lookup trigger is order-independent.
        // Time advice is driven by drop-off validity (ETA+30 is only applied AFTER drop-off is filled).
        if (!isPickupAirportActive()) {
          closeFlightSlideout();
          setAdviceUI(null, false);
          return;
        }

        var pickupAirport = getAirportForInput(pickupInput);
        if (!isSchipholAirportMatch(pickupAirport)) return;

        var norm = getNormalizedPickupFlightNumber(normVal);
        var valid = isValidPickupFlightNumber(norm);
        if (!valid) return;

        flightInfoState.status = "loading";
        flightDebug("lookup_start", { reason: reason || "", flightNumber: norm, date: dateYmd || "" });
        openFlightSlideout();
        renderFlightSkeleton();

        var date = dateYmd || getYmdForPickup();
        var baseUrl = (window.URBIXX_BOOKING_CONFIG && window.URBIXX_BOOKING_CONFIG.apiBaseUrl) ? window.URBIXX_BOOKING_CONFIG.apiBaseUrl : "https://urbixx-booking-backend.onrender.com";
        var url = baseUrl + "/api/schiphol/flight-lookup?flightNumber=" + encodeURIComponent(norm) + "&type=arrival&date=" + encodeURIComponent(date);

        var res = await fetch(url, { method: "GET", headers: { "Accept": "application/json" } });
        var json = await res.json().catch(function () { return {}; });

        if (!res.ok) {
          flightInfoState.status = "error";
          flightDebug("lookup_error_http", { status: res.status, flightNumber: norm });
          renderFlightError("Please try again in a moment.", true);
          return;
        }

        if (!json || !json.found || !json.dto) {
          flightInfoState.status = "not_found";
          flightDebug("lookup_not_found", { flightNumber: norm, date: date });
          renderFlightNotFound(norm, date);
          // Remove advice if no flight data
          setAdviceUI(null, false);
          return;
        }

        var dto = json.dto;
        flightInfoState.status = "success";
        flightInfoState.dto = dto;
        flightInfoState.lastSuccessKey = flightInfoState.lastLookupKey;
        var eta = dto.actualTime || dto.estimatedTime || null;
        var sta = dto.scheduledTime || null;
        renderFlightSuccess(dto, eta || sta, sta, dto.status || "");
        // Always ensure slide-out is visible on success (order-independent).
        openFlightSlideout();
        flightDebug("lookup_success", { flightNumber: dto.flightNumber || norm, eta: eta, sta: sta, status: dto.status });

        // Auto advice/apply: pickup time = ETA + 30m, but only after drop-off is filled.
        var advised = computeAdvisedFromDto(dto);
        if (advised) {
          tryApplyAdvisedPickupTime(advised, false);
        } else {
          setAdviceUI(null, false);
        }
      } catch (e) {
        flightInfoState.status = "error";
        flightDebug("lookup_exception", { message: (e && e.message) ? e.message : String(e || "") });
        openFlightSlideout();
        renderFlightError("Couldn’t load flight data.", true);
      }
    }

    // Trigger lookup (order-independent):
    // - Any time flight number changes
    // - Any time pickup becomes Schiphol (e.g. pickup selected first, then flight number, or vice versa)
    // - Any time pickup date changes (lookup uses date; fallback also exists server-side)
    if (flightPickupInputEl) {
      flightPickupInputEl.addEventListener("input", function () { schedulePickupFlightLookup("flight_number_input"); });
      flightPickupInputEl.addEventListener("change", function () { schedulePickupFlightLookup("flight_number_change"); });
    }
    if (pickupInput) {
      pickupInput.addEventListener("input", function () { schedulePickupFlightLookup("pickup_input"); });
      pickupInput.addEventListener("change", function () { schedulePickupFlightLookup("pickup_change"); });
    }
    if (pickupDateEl) {
      pickupDateEl.addEventListener("change", function () { schedulePickupFlightLookup("pickup_date_change"); });
    }
    // If values are prefilled (or restored), run one initial evaluation.
    try {
      setTimeout(function () { schedulePickupFlightLookup("init"); }, 0);
    } catch (e) {}

    function normalizeAirportStr(s) {
      return String(s || "")
        .toLowerCase()
        // strip apostrophes (straight + typographic)
        .replace(/['\u2019]/g, "")
        .replace(/[^a-z0-9\s\(\)\-\,]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    var ALL_AIRPORTS = (function() {
      var out = [];
      try {
        ["NL", "DE", "BE"].forEach(function(c) {
          (AIRPORTS[c] || []).forEach(function(a) {
            out.push({ code: a.code, name: a.name, query: a.query, country: c });
          });
        });
      } catch (e) {}
      return out;
    })();

    function detectAirportFromValue(rawValue) {
      var vRaw = String(rawValue || "").trim();
      var v = normalizeAirportStr(vRaw);
      if (!v) return null;

      // Exact query match (strong signal)
      for (var i = 0; i < ALL_AIRPORTS.length; i++) {
        var a0 = ALL_AIRPORTS[i];
        if (normalizeAirportStr(a0.query) === v) return a0;
      }

      // Contains airport name
      for (var j = 0; j < ALL_AIRPORTS.length; j++) {
        var a1 = ALL_AIRPORTS[j];
        var n = normalizeAirportStr(a1.name);
        if (n && v.indexOf(n) !== -1) return a1;
      }

      // Contains IATA code (word boundary or "(CODE)")
      for (var k = 0; k < ALL_AIRPORTS.length; k++) {
        var a2 = ALL_AIRPORTS[k];
        var code = String(a2.code || "").toLowerCase();
        if (!code) continue;
        if (v.indexOf("(" + code + ")") !== -1) return a2;
        try {
          var re = new RegExp("\\b" + code + "\\b", "i");
          if (re.test(vRaw)) return a2;
        } catch (e2) {}
      }

      // Generic airport keyword fallback
      if (v.indexOf("airport") !== -1 || v.indexOf("luchthaven") !== -1) {
        return { code: "", name: vRaw, query: vRaw, country: "" };
      }

      return null;
    }

    function setAirportMeta(inputEl, airport) {
      if (!inputEl) return;
      try {
        if (!airport) {
          delete inputEl.dataset.urbixxIsAirport;
          delete inputEl.dataset.urbixxAirportCode;
          delete inputEl.dataset.urbixxAirportName;
          return;
        }
        inputEl.dataset.urbixxIsAirport = "1";
        inputEl.dataset.urbixxAirportCode = airport.code || "";
        inputEl.dataset.urbixxAirportName = airport.name || "";
      } catch (e) {}
    }

    function getAirportForInput(inputEl) {
      if (!inputEl) return null;
      var val = (inputEl.value || "").trim();
      if (!val) {
        setAirportMeta(inputEl, null);
        return null;
      }
      var match = detectAirportFromValue(val);
      setAirportMeta(inputEl, match);
      return match;
    }

    function updateFlightPrompt(isPickup, airportMatch) {
      try {
        var inputEl = isPickup ? flightPickupInputEl : flightDropoffInputEl;
        var hintEl = isPickup ? flightPickupHintEl : flightDropoffHintEl;
        if (!hintEl) return;
        var v = inputEl && inputEl.value ? String(inputEl.value).trim() : "";
        if (v) {
          // When filled, hide the "fill in" prompt and show the airport name instead
          hintEl.textContent = (airportMatch && airportMatch.name) ? airportMatch.name : "";
        } else {
          hintEl.textContent = isPickup ? STRINGS.flightPromptPickup : STRINGS.flightPromptDropoff;
        }
      } catch (e) {}
    }

    function toggleFlightWrap(wrapEl, shouldShow, labelEl, airportMatch, hintEl, inputEl, isPickup) {
      if (!wrapEl) return;
      if (shouldShow) {
        wrapEl.classList.add("is-visible");
        wrapEl.setAttribute("aria-hidden", "false");
        if (labelEl) {
          var codeTxt = airportMatch && airportMatch.code ? " (" + airportMatch.code + ")" : "";
          // Pickup is mandatory -> show an asterisk
          var base = STRINGS.flightLabelPickup;
          labelEl.textContent = base + (isPickup ? "*" : "") + codeTxt;
        }
        // Required only for pickup airport
        if (inputEl) {
          if (isPickup) inputEl.setAttribute("required", "required");
          else inputEl.removeAttribute("required");
        }
        updateFlightPrompt(!!isPickup, airportMatch);
      } else {
        wrapEl.classList.remove("is-visible");
        wrapEl.setAttribute("aria-hidden", "true");
        if (labelEl) {
          labelEl.textContent = STRINGS.flightLabelPickup;
        }
        if (hintEl) hintEl.textContent = isPickup ? STRINGS.flightPromptPickup : STRINGS.flightPromptDropoff;
        if (inputEl) inputEl.removeAttribute("required");
      }
    }

    function updateFlightFieldsVisibility() {
      try {
        var pickupAirport = getAirportForInput(pickupInput);
        var dropoffAirport = getAirportForInput(dropoffInput);
        toggleFlightWrap(flightPickupWrap, !!pickupAirport, flightPickupLabelEl, pickupAirport, flightPickupHintEl, flightPickupInputEl, true);
        toggleFlightWrap(flightDropoffWrap, !!dropoffAirport, flightDropoffLabelEl, dropoffAirport, flightDropoffHintEl, flightDropoffInputEl, false);
        // Remove flight advice & close slide-out when pickup is not an airport
        if (!pickupAirport) {
          try { closeFlightSlideout(); } catch (e1) {}
          try { setAdviceUI(null, false); } catch (e2) {}
        }
        // Order-independent: if pickup becomes Schiphol and a valid flight number is already present,
        // this will trigger the lookup and open the slide-out on success.
        try { schedulePickupFlightLookup("update_flight_fields_visibility"); } catch (e3) {}
      } catch (e) {
        // no-op
      }
    }

    // Hide the "fill in flight number" prompt as soon as a value is entered
    if (flightPickupInputEl) {
      flightPickupInputEl.addEventListener("input", function() {
        updateFlightPrompt(true, getAirportForInput(pickupInput));
      });
      flightPickupInputEl.addEventListener("change", function() {
        updateFlightPrompt(true, getAirportForInput(pickupInput));
      });
    }
    if (flightDropoffInputEl) {
      flightDropoffInputEl.addEventListener("input", function() {
        updateFlightPrompt(false, getAirportForInput(dropoffInput));
      });
      flightDropoffInputEl.addEventListener("change", function() {
        updateFlightPrompt(false, getAirportForInput(dropoffInput));
      });
    }

    var activeCountry = "NL";

    function isStationTab(code) {
      return String(code || "").indexOf("ST_") === 0;
    }

    function renderAirportSelect() {
      if (!airportSelect) return;
      var list = isStationTab(activeCountry) ? (STATIONS[activeCountry] || []) : (AIRPORTS[activeCountry] || []);
      airportSelect.innerHTML = "";

      var opt0 = document.createElement("option");
      opt0.value = "";
      opt0.textContent = isStationTab(activeCountry) ? STRINGS.stationsSelectPlaceholder : STRINGS.airportsSelectPlaceholder;
      airportSelect.appendChild(opt0);

      list.forEach(function(a) {
        var opt = document.createElement("option");
        opt.value = a.query;
        opt.textContent = isStationTab(activeCountry) ? a.name : (a.name + " (" + a.code + ")");
        airportSelect.appendChild(opt);
      });
    }

    function setActiveCountry(code) {
      activeCountry = code;
      if (airportFilterBtns && airportFilterBtns.length) {
        Array.prototype.forEach.call(airportFilterBtns, function(b) {
          var c = b.getAttribute("data-urbixx-location-tab");
          if (c === code) b.classList.add("is-active");
          else b.classList.remove("is-active");
        });
      }
      renderAirportSelect();
    }

    if (airportFilterBtns && airportFilterBtns.length) {
      Array.prototype.forEach.call(airportFilterBtns, function(b) {
        b.addEventListener("click", function() {
          var c = b.getAttribute("data-urbixx-location-tab");
          if (!c) return;
          setActiveCountry(c);
        });
      });
    }

    if (airportSelect) {
      renderAirportSelect();
      airportSelect.addEventListener("change", function() {
        var q = airportSelect.value;
        if (!q) return;
        var targetInput = getTargetInput();
        if (!targetInput) return;
        // Only airports should trigger flight number UI
        if (isStationTab(activeCountry)) {
          setAirportMeta(targetInput, null);
          updateFlightFieldsVisibility();
        } else {
          var selectedAirport = detectAirportFromValue(q);
          setAirportMeta(targetInput, selectedAirport);
          updateFlightFieldsVisibility();
        }
        var token = markAutofill(targetInput, q);
        setFieldValue(targetInput, q, { emitInput: false, emitChange: true, blur: true });
        geocodeAddress(q)
          .then(function(formatted) {
            if (canApplyAutofill(targetInput, token, q)) {
              setFieldValue(targetInput, formatted, { emitInput: false, emitChange: true, blur: true });
            }
          })
          .catch(function() {})
          .finally(function() {
            scheduleDistanceUpdate();
          });
      });
    }

    // Mobile-only: gentle auto-scroll hint for the quick tiles row
    (function initQuickTilesAutoScroll() {
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      if (window.matchMedia && window.matchMedia("(min-width: 921px)").matches) return;

      var row = document.querySelector("[data-urbixx-quick-row]");
      if (!row) return;

      var pausedUntil = 0;
      var dir = 1;
      var tickMs = 2400;

      function pause(ms) {
        pausedUntil = Date.now() + (ms || 6000);
      }

      ["pointerdown", "touchstart", "wheel"].forEach(function(evt) {
        row.addEventListener(evt, function() { pause(8000); }, { passive: true });
      });
      row.addEventListener("scroll", function() { pause(6000); }, { passive: true });

      function step() {
        try {
          var max = row.scrollWidth - row.clientWidth;
          if (max <= 12) return;

          if (Date.now() < pausedUntil) return;

          var tile = row.querySelector(".urbixx-quick-tile");
          var delta = tile ? Math.max(140, tile.getBoundingClientRect().width + 12) : 180;

          var next = row.scrollLeft + dir * delta;
          if (next >= max) {
            next = max;
            dir = -1;
          } else if (next <= 0) {
            next = 0;
            dir = 1;
          }

          row.scrollTo({ left: next, behavior: "smooth" });
        } catch (e) {
          // no-op
        }
      }

      // start after a short delay so it feels like a hint
      setTimeout(function() {
        step();
        setInterval(step, tickMs);
      }, 1400);
    })();

    // Toggle labels YES/NO and show/hide return section
    function updateToggleLabels() {
      var isReturn = !!returnToggle.checked;
      returnStatus.textContent = isReturn ? "Yes" : "No";
      waitStatus.textContent = waitToggle.checked ? "Yes" : "No";
      if (isReturn) {
        returnSection.style.display = "block";
      } else {
        returnSection.style.display = "none";
      }
    }

    returnToggle.addEventListener("change", function() {
      updateToggleLabels();
      if (lastQuote) {
        recalcBtn.style.display = "inline-flex";
      }
    });

    waitToggle.addEventListener("change", function() {
      updateToggleLabels();
      if (lastQuote) {
        recalcBtn.style.display = "inline-flex";
      }
    });

    updateToggleLabels();

    // Mobile hint click -> open panel & scroll
    if (routeHint) {
      routeHint.addEventListener("click", function() {
        try {
          if (!mapPanel) return;
          if (mapPanel.classList.contains("urbixx-open")) return;
          urbixxOpenMapPanel();
          if (showMapBtn) showMapBtn.textContent = "Close map";
        } catch (e) {}
      });
    }

    // Shared price calculation logic
    async function performPriceCalculation() {
      var pickupAddress = document.getElementById("pickup-address").value;
      var dropoffAddress = document.getElementById("dropoff-address").value;
      var pickupDate = document.getElementById("pickup-date").value;
      var pickupTime = document.getElementById("pickup-time").value;
      var returnDate = document.getElementById("return-date").value;
      var returnTime = document.getElementById("return-time").value;
      var passengersVal = document.getElementById("passengers").value || "1";

      var isReturn = !!returnToggle.checked;
      var waitOnSpot = !!waitToggle.checked;

      if (!pickupAddress || !dropoffAddress) {
        alert("Please fill in pickup and destination first.");
        return;
      }

      if (!pickupDate || !pickupTime) {
        openDateTimeSection();
        alert("Please choose pickup date and time.");
        return;
      }

      if (isReturn && (!returnDate || !returnTime)) {
        openDateTimeSection();
        alert("Please choose return pickup date and time.");
        return;
      }

      priceResult.textContent = "Calculating fare...";
      priceResult.classList.add("urbixx-show");
      priceResult.scrollIntoView({ behavior: "smooth", block: "nearest" });

      try {
        var res = await fetch(apiBaseUrl + "/api/calculate-price", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            pickupAddress: pickupAddress,
            dropoffAddress: dropoffAddress,
            pickupDate: pickupDate,
            pickupTime: pickupTime
          })
        });

        if (!res.ok) {
          throw new Error("Failed to calculate fare.");
        }

        var data = await res.json();

        var distanceKm = data.distanceKm;
        var baseDuration = data.durationMinutes;

        var oneWayPrice = data.price;
        var totalPrice = isReturn ? oneWayPrice * 2 : oneWayPrice;

        // verrijk quote zodat backend alles heeft
        data.priceBase = oneWayPrice;
        data.priceTotal = totalPrice;
        data.returnRide = isReturn;
        data.waitOnSpot = waitOnSpot;
        data.passengers = parseInt(passengersVal, 10) || 1;
        data.returnDate = isReturn ? returnDate : null;
        data.returnTime = isReturn ? returnTime : null;
        data.price = totalPrice; // backend gebruikt quote.price als fallback

        lastQuote = data;
        try { updateStickyTotalPrice(); } catch (e0) {}

        var labelRoute = isReturn ? "round trip" : "one way";

        priceResult.textContent =
          "Estimated " +
          labelRoute +
          " fare: \u20AC " +
          totalPrice.toFixed(2) +
          " (distance: " +
          distanceKm.toFixed(1) +
          " km, duration: ~" +
          Math.round(baseDuration) +
          " min one way)";
        priceResult.classList.add("urbixx-show");

        // Update route planner fare (modal header)
        try {
          if (mapFareEl) {
            mapFareEl.textContent = "Estimated fare: \u20AC " + totalPrice.toFixed(2);
          }
        } catch (eFare) {}

        // Inline distance under drop-off (max 2 decimals)
        setInlineDistance(distanceKm, baseDuration);
        
        // Smooth scroll to price result
        setTimeout(function() {
          priceResult.scrollIntoView({ behavior: "smooth", block: "nearest" });
        }, 100);

        urbixxShowRoute(pickupAddress, dropoffAddress);

        if (continueBtn) continueBtn.disabled = false;
        try { updateStickyTotalPrice(); } catch (e1) {}

        recalcBtn.style.display = "inline-flex";

        if (routeHint && window.innerWidth <= 768) {
          routeHint.style.display = "flex";
        }
      } catch (err) {
        console.error(err);
        priceResult.textContent =
          "We were unable to calculate the fare. Please try again.";
        priceResult.classList.add("urbixx-show");
      }
    }

    // 1. Calculate fare (first click may just open date/time)
    calculateBtn.addEventListener("click", function() {
      if (!dateTimeOpen) {
        openDateTimeSection();
        return;
      }
      performPriceCalculation();
    });

    // 1b. Recalculate after toggles
    recalcBtn.addEventListener("click", function() {
      performPriceCalculation();
    });

    // 2. To onboarding step - only after we have a quote
    continueBtn.addEventListener("click", function() {
      if (!lastQuote) {
        alert("Please calculate the fare first.");
        return;
      }

      // Step change: ensure mobile quick-toggle dock is hidden (Step 1 only)
      try { if (window.__urbixxQuickToggleDockHide) window.__urbixxQuickToggleDockHide(); } catch (eDockQ0) {}

      step1.style.display = "none";
      onboardingStep.style.display = "block";
      onboardingStep.scrollIntoView({ behavior: "smooth", block: "start" });
      try { urbixxSetTotalsDocked(false, 'enter_onboarding'); } catch (eDock0) {}
      setTimeout(function() { try { urbixxRefreshTotalsDocking(); } catch (eDock1) {} }, 500);
      
      // Initialize onboarding experience
      updateOnboardingTotalPrice();
      updateIndividualPrices();
      
      // Show playlist genre selector if playlist is already checked
      var playlistCheckbox = document.getElementById('onboarding-playlist');
      if (playlistCheckbox && playlistCheckbox.checked) {
        var genreWrapper = document.getElementById('onboarding-playlist-genre-wrapper');
        if (genreWrapper) {
          genreWrapper.classList.add('urbixx-open');
        }
      }
      
      // Setup quantity controls
      setTimeout(function() {
        setupQuantityControls();
      }, 100);
    });

    // Back from onboarding to step 1
    if (onboardingBackBtn) {
      onboardingBackBtn.addEventListener("click", function() {
        onboardingStep.style.display = "none";
        step1.style.display = "block";
        step1.scrollIntoView({ behavior: "smooth", block: "start" });
        try { urbixxSetTotalsDocked(false, 'leave_onboarding'); } catch (eDock2) {}
        try { updateStickyTotalPrice(); } catch (eStickyHide1) {}
        try { if (window.__urbixxQuickToggleDockUpdate) window.__urbixxQuickToggleDockUpdate(); } catch (eDockQ1) {}
      });
    }

    // Continue from onboarding to review step
    if (onboardingContinueBtn) {
      onboardingContinueBtn.addEventListener("click", function() {
        // Collect all selected items
        collectOnboardingSelections();
        
        // Go to review step
        onboardingStep.style.display = "none";
        step2.style.display = "block";
        updateReviewSummary();
        step2.scrollIntoView({ behavior: "smooth", block: "start" });
        try { urbixxSetTotalsDocked(false, 'leave_onboarding'); } catch (eDock3) {}
        try { updateStickyTotalPrice(); } catch (eStickyHide2) {}
      });
    }

    // Initialize sticky total on load (hidden until quote exists)
    try { updateStickyTotalPrice(); } catch (e) {}
    try { urbixxSetupTotalsDocking(); } catch (eDockInit) {}

    // ---- Extras pricing (pooled credits) ----
    // Uses the pure function from `assets/urbixx-extras-pricing.js`.
    function computePricingFromDom() {
      var passengerCount = parseInt((document.getElementById('passengers') || {}).value, 10) || 1;

      var beverages = [];
      document.querySelectorAll('#urbixx-onboarding-step input[name="beverages[]"]').forEach(function(cb) {
        var qtyTarget = cb.getAttribute('data-qty-target');
        var qtyInput = qtyTarget ? document.getElementById(qtyTarget) : null;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) : 0;
        var unitPrice = parseFloat(cb.getAttribute('data-price')) || 0;
        beverages.push({
          id: qtyTarget || cb.value,
          name: cb.value,
          qty: qty,
          unitPrice: unitPrice
        });
      });

      var snacks = [];
      document.querySelectorAll('#urbixx-onboarding-step input[name="snacks[]"]').forEach(function(cb) {
        var qtyTarget = cb.getAttribute('data-qty-target');
        var qtyInput = qtyTarget ? document.getElementById(qtyTarget) : null;
        var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 0) : 0;
        var unitPrice = parseFloat(cb.getAttribute('data-price')) || 0;
        snacks.push({
          id: qtyTarget || cb.value,
          name: cb.value,
          qty: qty,
          unitPrice: unitPrice,
          isGum: (qtyTarget === 'snack-gum') || (String(cb.value || '').toLowerCase().indexOf('gum') >= 0) || (String(cb.value || '').toLowerCase().indexOf('kauwgom') >= 0)
        });
      });

      var fn = (window && window.UrbixxComputeExtrasPricing) ? window.UrbixxComputeExtrasPricing : null;
      if (!fn) {
        return { lineItems: [], totals: { passengerCount: passengerCount, paidDrinksTotal: 0, paidSnacksTotal: 0, extrasTotal: 0 } };
      }
      return fn({ passengerCount: passengerCount, beverages: beverages, snacks: snacks });
    }

    // Function to collect onboarding selections
    function collectOnboardingSelections() {
      selectedExtras = [];
      selectedBeverages = [];
      selectedSnacks = [];
      extrasTotalPrice = 0;

      // Collect extras
      // Include disabled checked extras too (these are included/free selections like WiFi)
      var extraCheckboxes = document.querySelectorAll('#urbixx-onboarding-step input[name="extras[]"]:checked');
      extraCheckboxes.forEach(function(cb) {
        var price = parseFloat(cb.getAttribute('data-price')) || 0;
        var extraData = {
          name: cb.value,
          price: price,
          included: cb.disabled || price === 0
        };
        
        // Add playlist genre if it's the playlist extra
        if (cb.value === 'playlist') {
          var genreSelect = document.getElementById('onboarding-playlist-genre');
          if (genreSelect) {
            extraData.genre = genreSelect.value;
          }
        }
        
        selectedExtras.push(extraData);
        // Only add to paid extras total if it isn't an included/free selection
        if (!extraData.included) {
          extrasTotalPrice += price;
        }
      });

      // Collect beverages + snacks using pooled credit pricing
      var pricing = computePricingFromDom();
      (pricing.lineItems || []).forEach(function(li) {
        if (!li) return;
        if (li.category === 'beverage' && li.qty > 0) {
          selectedBeverages.push({
            name: li.name,
            requestedQty: li.qty,
            freeQty: li.freeQty,
            paidQty: li.paidQty,
            price: li.unitPrice,
            total: li.lineTotal
          });
          extrasTotalPrice += li.lineTotal;
        }
        if (li.category === 'snack' && li.qty > 0) {
          selectedSnacks.push({
            name: li.name,
            requestedQty: li.qty,
            freeQty: li.freeQty,
            paidQty: li.paidQty,
            price: li.unitPrice,
            total: li.lineTotal
          });
          extrasTotalPrice += li.lineTotal;
        }
      });
    }

    // Function to update onboarding total price display
    function updateOnboardingTotalPrice() {
      collectOnboardingSelections();
      var totalEl = document.getElementById('onboarding-total-price-value');
      if (totalEl) {
        totalEl.textContent = '\u20AC' + extrasTotalPrice.toFixed(2).replace('.', ',');
        // Animate price change
        totalEl.style.transform = 'scale(1.1)';
        setTimeout(function() {
          totalEl.style.transform = 'scale(1)';
        }, 200);
      }

      // Update individual item prices
      updateIndividualPrices();

      // Update docked breakdown (extras / trip / estimated) + meta (counts)
      try { updateTotalsBreakdownUi(); } catch (e0) {}
      try { updateExtrasMetaUi(); } catch (e1) {}

      // Update sticky total (base fare + extras)
      updateStickyTotalPrice();
    }

    function formatEur(n) {
      var v = Number(n || 0);
      if (!isFinite(v)) v = 0;
      return '\u20AC' + v.toFixed(2).replace('.', ',');
    }

    function computeExtrasCounts() {
      var out = { drinks: 0, snacks: 0, items: 0 };
      try {
        var pricing = computePricingFromDom();
        var lineItems = (pricing && pricing.lineItems) ? pricing.lineItems : [];
        lineItems.forEach(function(li) {
          if (!li) return;
          if (li.category === 'beverage') out.drinks += (li.qty || 0);
          if (li.category === 'snack') out.snacks += (li.qty || 0);
        });
        out.items = out.drinks + out.snacks;
      } catch (e) {}
      return out;
    }

    function updateTotalsBreakdownUi() {
      try {
        var tripEl = document.getElementById('urbixx-onboarding-trip-total-value');
        var estEl = document.getElementById('urbixx-onboarding-estimated-total-value');
        if (!tripEl || !estEl) return;

        var base = (lastQuote && lastQuote.price) ? Number(lastQuote.price) : 0;
        if (!isFinite(base)) base = 0;
        var total = base + (Number(extrasTotalPrice) || 0);
        if (!isFinite(total)) total = base;

        tripEl.textContent = formatEur(base);
        estEl.textContent = formatEur(total);
      } catch (e) {}
    }

    function updateExtrasMetaUi() {
      try {
        var metaEl = document.getElementById('urbixx-onboarding-extras-meta');
        if (!metaEl) return;
        var c = computeExtrasCounts();
        if (!c || !c.items) {
          metaEl.style.display = 'none';
          metaEl.textContent = '';
          return;
        }
        var drinksText = c.drinks + (c.drinks === 1 ? ' drink' : ' drinks');
        var snacksText = c.snacks + (c.snacks === 1 ? ' snack' : ' snacks');
        metaEl.style.display = 'block';
        metaEl.textContent = 'Includes ' + drinksText + ' and ' + snacksText + '.';
      } catch (e) {}
    }

    function updateStickyTotalPrice() {
      try {
        var bar = document.getElementById('urbixx-sticky-total');
        var valEl = document.getElementById('urbixx-sticky-total-value');
        var chipEl = document.getElementById('urbixx-sticky-total-chip');
        if (!bar || !valEl) return;

        // This floating tile is meant for the Extras (onboarding) step only.
        // Other steps already show totals in their own layout.
        try {
          if (!onboardingStep || onboardingStep.style.display === 'none') {
            bar.style.display = 'none';
            return;
          }
        } catch (eStep) {}

        var base = (lastQuote && lastQuote.price) ? Number(lastQuote.price) : 0;
        var total = base + (Number(extrasTotalPrice) || 0);

        if (!lastQuote) {
          bar.style.display = 'none';
          return;
        }

        bar.style.display = 'block';
        valEl.textContent = formatEur(total);

        // Optional: show count of selected items (snacks + drinks)
        if (chipEl) {
          var c = computeExtrasCounts();
          var n = (c && c.items) ? c.items : 0;
          if (n > 0) {
            chipEl.style.display = 'inline-flex';
            chipEl.textContent = n + (n === 1 ? ' item' : ' items');
          } else {
            chipEl.style.display = 'none';
            chipEl.textContent = '';
          }
        }

        // Keep docked breakdown in sync even outside the onboarding step
        try { updateTotalsBreakdownUi(); } catch (e0) {}
        try { updateExtrasMetaUi(); } catch (e1) {}
      } catch (e) {}
    }

    // --- Totals docking behaviour (floating tile <-> docked breakdown) ---
    var __urbixxTotalsDocked = false;
    var __urbixxTotalsObserver = null;

    function urbixxIsOnboardingVisible() {
      try { return !!(onboardingStep && onboardingStep.style.display !== 'none'); } catch (e) { return false; }
    }

    function urbixxSetTotalsDocked(next, reason) {
      try {
        var widget = document.getElementById('urbixx-booking-widget');
        if (!widget) return;
        var want = !!next;
        if (__urbixxTotalsDocked === want) return;
        __urbixxTotalsDocked = want;
        widget.classList.toggle('urbixx-totals--docked', want);

        // Premium spring-in (subtle), GSAP if available. CSS transitions are the baseline.
        try {
          if (window.gsap) {
            var dockInner = document.querySelector('#onboarding-total-price .urbixx-totals-dock__inner');
            var stickyInner = document.querySelector('#urbixx-sticky-total .urbixx-sticky-total__inner');
            if (want && dockInner) {
              window.gsap.fromTo(dockInner, { y: 12, scale: 0.985, opacity: 0 }, { y: 0, scale: 1, opacity: 1, duration: 0.55, ease: 'power3.out', clearProps: 'transform' });
              var estVal = document.getElementById('urbixx-onboarding-estimated-total-value');
              if (estVal) window.gsap.fromTo(estVal, { scale: 0.98 }, { scale: 1, duration: 0.45, ease: 'power3.out', clearProps: 'transform' });
            }
            if (!want && stickyInner) {
              window.gsap.fromTo(stickyInner, { y: 16, scale: 0.985, opacity: 0 }, { y: 0, scale: 1, opacity: 1, duration: 0.45, ease: 'power3.out', clearProps: 'transform' });
            }
          }
        } catch (eAnim) {}
      } catch (e) {}
    }

    function urbixxRefreshTotalsDocking() {
      try {
        if (!urbixxIsOnboardingVisible()) {
          urbixxSetTotalsDocked(false, 'not_onboarding');
          return;
        }
        var sentinel = document.getElementById('urbixx-totals-sentinel');
        if (!sentinel) return;
        var r = sentinel.getBoundingClientRect();
        // Dock when you're near the bottom area (prevents the zoom/height jitter feel)
        var dock = r.top < (window.innerHeight - 140) && r.bottom > 0;
        urbixxSetTotalsDocked(dock, 'manual');
      } catch (e) {}
    }

    function urbixxSetupTotalsDocking() {
      try {
        var sentinel = document.getElementById('urbixx-totals-sentinel');
        if (!sentinel) return;

        // Prefer IntersectionObserver, but keep a manual fallback.
        if ('IntersectionObserver' in window) {
          if (__urbixxTotalsObserver) {
            try { __urbixxTotalsObserver.disconnect(); } catch (e0) {}
          }
          __urbixxTotalsObserver = new IntersectionObserver(function(entries) {
            try {
              if (!urbixxIsOnboardingVisible()) {
                urbixxSetTotalsDocked(false, 'not_onboarding');
                return;
              }
              var any = false;
              entries.forEach(function(en) { if (en && en.isIntersecting) any = true; });
              urbixxSetTotalsDocked(any, 'io');
            } catch (e1) {}
          }, { root: null, threshold: 0.01, rootMargin: '0px 0px -140px 0px' });
          __urbixxTotalsObserver.observe(sentinel);
        } else {
          window.addEventListener('scroll', urbixxRefreshTotalsDocking, { passive: true });
          window.addEventListener('resize', urbixxRefreshTotalsDocking);
        }

        // Prime the state
        setTimeout(function() { urbixxRefreshTotalsDocking(); }, 0);
      } catch (e) {}
    }

    // Function to update individual item price displays
    function updateIndividualPrices() {
      var pricing = computePricingFromDom();
      var lineItems = pricing.lineItems || [];

      // Apply gum cap back to DOM (hard cap)
      lineItems.forEach(function(li) {
        if (!li || li.category !== 'snack' || li.id !== 'snack-gum') return;
        var gumInput = document.getElementById('snack-gum');
        if (gumInput && String(gumInput.value || '') !== String(li.qty)) gumInput.value = li.qty;
      });

      lineItems.forEach(function(li) {
        if (!li || !li.id) return;
        var priceEl = document.getElementById(li.id + '-price');
        if (!priceEl) return;
        if (li.lineTotal > 0) {
          priceEl.textContent = '\u20AC' + li.lineTotal.toFixed(2).replace('.', ',');
          priceEl.classList.remove('free');
        } else {
          priceEl.textContent = 'Gratis';
          priceEl.classList.add('free');
        }
      });
    }

    // Function to update review summary with all selections
    function updateReviewSummary() {
      if (!lastQuote) return;

      var pickupAddress = document.getElementById("pickup-address").value;
      var dropoffAddress = document.getElementById("dropoff-address").value;
      var pickupDate = document.getElementById("pickup-date").value;
      var pickupTime = document.getElementById("pickup-time").value;
      var returnDate = document.getElementById("return-date").value;
      var returnTime = document.getElementById("return-time").value;

      var distanceKm = lastQuote.distanceKm;
      var durationMinutes = lastQuote.durationMinutes;
      var passengers = lastQuote.passengers || 1;
      var isReturn = !!lastQuote.returnRide;
      var waitOnSpot = !!lastQuote.waitOnSpot;

      // Calculate total price including extras
      var basePrice = lastQuote.price || 0;
      var totalPrice = basePrice + extrasTotalPrice;

      summaryTripType.textContent = isReturn ? "Round trip" : "One-way ride";

      summaryRoute.textContent = isReturn
        ? pickupAddress + " â‡„ " + dropoffAddress
        : pickupAddress + " \u2192 " + dropoffAddress;

      summaryDatetime.textContent = pickupDate + " at " + pickupTime;

      if (isReturn && returnDate && returnTime) {
        summaryReturnRow.style.display = "block";
        summaryReturnDatetime.textContent = returnDate + " at " + returnTime;
      } else {
        summaryReturnRow.style.display = "none";
        summaryReturnDatetime.textContent = "";
      }

      summaryPassengers.textContent =
        passengers + (passengers === 1 ? " passenger" : " passengers");
      summaryWait.textContent = waitOnSpot ? "Yes" : "No";

      // Update price to include extras
      summaryPrice.textContent = "\u20AC " + totalPrice.toFixed(2);
      summaryDistance.textContent = distanceKm.toFixed(1) + " km";
      summaryDuration.textContent = "~" + Math.round(durationMinutes) + " min";

      summaryRouteDesc.textContent =
        lastRouteSummaryText ||
        "Fastest route calculated for your pickup and drop-off.";

      var suggestion = "Smooth trip at this time of day.";
      var timeParts = (pickupTime || "").split(":");
      var hourStr = timeParts[0] || "0";
      var hour = parseInt(hourStr, 10);
      var isMorningRush = hour >= 7 && hour < 9;
      var isEveningRush = hour >= 16 && hour < 19;

      if (isMorningRush || isEveningRush) {
        suggestion =
          "Expect heavier traffic around rush hour. Urbixx keeps an eye on timing, but we recommend planning 10\u201315 extra minutes.";
      } else if (durationMinutes > 45) {
        suggestion =
          "Longer ride \u2014 perfect moment to relax, charge your phone and set the vibe before you arrive.";
      }

      if (isReturn) {
        suggestion += " A smooth round trip is included in your estimate.";
      }

      summarySuggestion.textContent = suggestion;

      // Add extras summary
      var extrasSummary = [];
      if (selectedExtras.length > 0) {
        selectedExtras.forEach(function(extra) {
          if (extra.price > 0) {
            extrasSummary.push(extra.name + " (+\u20AC" + extra.price.toFixed(2) + ")");
          }
        });
      }
      if (selectedBeverages.length > 0) {
        selectedBeverages.forEach(function(bev) {
          extrasSummary.push(bev.name + " x" + bev.requestedQty + " (+\u20AC" + bev.total.toFixed(2) + ")");
        });
      }
      if (selectedSnacks.length > 0) {
        selectedSnacks.forEach(function(snack) {
          extrasSummary.push(snack.name + " x" + snack.requestedQty + " (+\u20AC" + snack.total.toFixed(2) + ")");
        });
      }

      // Update extras summary
      var summaryExtrasRow = document.getElementById('summary-extras-row');
      var summaryBasePriceRow = document.getElementById('summary-base-price-row');
      var summaryExtrasPriceRow = document.getElementById('summary-extras-price-row');
      var summaryBasePrice = document.getElementById('summary-base-price');
      var summaryExtrasPrice = document.getElementById('summary-extras-price');
      var summaryExtrasList = document.getElementById('summary-extras-list');

      if (extrasSummary.length > 0) {
        if (summaryExtrasRow) {
          summaryExtrasRow.style.display = 'block';
          if (summaryExtrasList) {
            summaryExtrasList.textContent = extrasSummary.join(', ');
          }
        }
        if (summaryExtrasPriceRow && summaryExtrasPrice) {
          summaryExtrasPriceRow.style.display = 'block';
          summaryExtrasPrice.textContent = '\u20AC ' + extrasTotalPrice.toFixed(2);
        }
        if (summaryBasePriceRow && summaryBasePrice) {
          summaryBasePriceRow.style.display = 'block';
          summaryBasePrice.textContent = '\u20AC ' + basePrice.toFixed(2);
        }
      } else {
        if (summaryExtrasRow) summaryExtrasRow.style.display = 'none';
        if (summaryExtrasPriceRow) summaryExtrasPriceRow.style.display = 'none';
        if (summaryBasePriceRow) summaryBasePriceRow.style.display = 'none';
      }

      var evCost = distanceKm * COST_PER_KM_EV;
      var petrolCost = distanceKm * COST_PER_KM_PETROL;
      var dieselCost = distanceKm * COST_PER_KM_DIESEL;

      summaryCostEv.textContent = "\u20AC " + evCost.toFixed(2);
      summaryCostPetrol.textContent = "\u20AC " + petrolCost.toFixed(2);
      summaryCostDiesel.textContent = "\u20AC " + dieselCost.toFixed(2);

      var petrolCO2 = distanceKm * CO2_PETROL_PER_KM;
      var dieselCO2 = distanceKm * CO2_DIESEL_PER_KM;
      var avgIceCO2 = (petrolCO2 + dieselCO2) / 2;
      var savedKg = avgIceCO2;

      co2Text.textContent =
        "By choosing Urbixx, you're actively reducing the environmental impact of your journey. " +
        "This electric trip avoids approximately " +
        savedKg.toFixed(1) +
        " kg of Co2 emissions compared to petrol or diesel rides.";

      bookingMessageStep2.textContent = "";
    }

    // Terug naar onboarding step vanuit review
    backBtn.addEventListener("click", function() {
      step2.style.display = "none";
      onboardingStep.style.display = "block";
      onboardingStep.scrollIntoView({ behavior: "smooth", block: "start" });
      try { updateOnboardingTotalPrice(); } catch (eTotalsBack) {}
      try { urbixxSetTotalsDocked(false, 'back_to_onboarding'); } catch (eDock4) {}
      setTimeout(function() { try { urbixxRefreshTotalsDocking(); } catch (eDock5) {} }, 500);
    });

    // Setup quantity controls for beverages and snacks (single delegated handler; prevents double-binding)
    function setupQuantityControls() {
      if (!onboardingStep) return;
      if (onboardingStep.getAttribute('data-urbixx-qty-bound') === 'true') return;
      onboardingStep.setAttribute('data-urbixx-qty-bound', 'true');

      function syncCheckboxForQtyInput(inputEl) {
        try {
          if (!inputEl || !inputEl.id) return;
          var cb = onboardingStep.querySelector('input[type="checkbox"][data-qty-target="' + inputEl.id + '"]');
          if (!cb) return;
          var qty = parseInt(inputEl.value, 10) || 0;
          if (qty > 0) cb.checked = true;
          if (qty === 0 && inputEl.id !== 'snack-gum') cb.checked = false;
        } catch (e) {}
      }

      function applyQty(inputEl, delta) {
        if (!inputEl || inputEl.type !== 'number') return;
        var min = parseInt(inputEl.getAttribute('min'), 10);
        if (!isFinite(min)) min = 0;
        var max = parseInt(inputEl.getAttribute('max'), 10);
        if (!isFinite(max)) max = 10;
        var cur = parseInt(inputEl.value, 10) || 0;
        var next = (window && window.UrbixxNextQty) ? window.UrbixxNextQty(cur, delta, { min: min, max: max }) : Math.max(min, Math.min(max, cur + delta));
        inputEl.value = next;
        syncCheckboxForQtyInput(inputEl);
        updateOnboardingTotalPrice();
      }

      onboardingStep.addEventListener('click', function(e) {
        var t = e && e.target ? e.target : null;
        if (!t) return;

        if (t.classList && t.classList.contains('urbixx-qty-btn--minus')) {
          e.preventDefault();
          applyQty(t.nextElementSibling, -1);
          return;
        }
        if (t.classList && t.classList.contains('urbixx-qty-btn--plus')) {
          e.preventDefault();
          applyQty(t.previousElementSibling, +1);
          return;
        }
      });

      onboardingStep.addEventListener('change', function(e) {
        var t = e && e.target ? e.target : null;
        if (!t) return;

        if (t.classList && t.classList.contains('urbixx-qty-input')) {
          applyQty(t, 0);
          return;
        }

        if (t.type === 'checkbox' && (t.name === 'beverages[]' || t.name === 'snacks[]')) {
          var qtyTarget = t.getAttribute('data-qty-target');
          var qtyInput = qtyTarget ? document.getElementById(qtyTarget) : null;
          if (!qtyInput) return;
          if (t.checked) {
            if ((parseInt(qtyInput.value, 10) || 0) === 0) qtyInput.value = 1;
          } else {
            qtyInput.value = 0;
          }
          syncCheckboxForQtyInput(qtyInput);
          updateOnboardingTotalPrice();
          return;
        }

        if (t.type === 'checkbox' && t.name === 'extras[]') {
          updateOnboardingTotalPrice();
          if (t.id === 'onboarding-playlist') {
            var genreWrapper = document.getElementById('onboarding-playlist-genre-wrapper');
            if (genreWrapper) {
              if (t.checked) genreWrapper.classList.add('urbixx-open');
              else genreWrapper.classList.remove('urbixx-open');
            }
          }
        }
      });
    }

      // Listen for passengers changes to update pooled credits + caps (gum)
      var passengersSelect = document.getElementById('passengers');
      if (passengersSelect) {
        passengersSelect.addEventListener('change', function() {
          if (onboardingStep && onboardingStep.style.display !== 'none') {
            var newPassengers = parseInt(passengersSelect.value, 10) || 1;
            var gumQty = document.getElementById('snack-gum');
            if (gumQty) {
              gumQty.value = Math.min(parseInt(gumQty.value, 10) || 0, newPassengers);
            }
            updateOnboardingTotalPrice();
          }
        });
      }

    // 3. Echte booking (API create-booking) vanuit stap 2
    finalBookingBtn.addEventListener("click", async function() {
      if (!lastQuote) {
        alert("Please calculate the fare first.");
        return;
      }

      var pickupAddress = document.getElementById("pickup-address").value;
      var dropoffAddress = document.getElementById("dropoff-address").value;
      var pickupDate = document.getElementById("pickup-date").value;
      var pickupTime = document.getElementById("pickup-time").value;
      var returnDate = document.getElementById("return-date").value;
      var returnTime = document.getElementById("return-time").value;
      var customerName = document.getElementById("customer-name").value;
      var customerPhone = document.getElementById("customer-phone").value;
      var customerEmail = document.getElementById("customer-email").value;
      var flightNumberPickup = (document.getElementById("urbixx-flight-number-pickup") || {}).value || "";
      var flightNumberDropoff = (document.getElementById("urbixx-flight-number-dropoff") || {}).value || "";
      flightNumberPickup = String(flightNumberPickup || "").trim();
      flightNumberDropoff = String(flightNumberDropoff || "").trim();

      if (!customerName || !customerPhone || !customerEmail) {
        alert("Please fill in your name, phone number and email.");
        return;
      }

      bookingMessageStep2.textContent = "Your booking is being processed...";
      finalBookingBtn.disabled = true;

      try {
        // Persist on quote for downstream usage (emails, WhatsApp, admin views, etc.)
        if (lastQuote) {
          lastQuote.flightNumberPickup = flightNumberPickup || null;
          lastQuote.flightNumberDropoff = flightNumberDropoff || null;
        }

        var res = await fetch(apiBaseUrl + "/api/create-booking", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            pickupAddress: pickupAddress,
            dropoffAddress: dropoffAddress,
            pickupDate: pickupDate,
            pickupTime: pickupTime,
            returnDate: lastQuote.returnRide ? returnDate : null,
            returnTime: lastQuote.returnRide ? returnTime : null,
            customerName: customerName,
            customerPhone: customerPhone,
            customerEmail: customerEmail,
            flightNumberPickup: flightNumberPickup || null,
            flightNumberDropoff: flightNumberDropoff || null,
            passengers: lastQuote.passengers || 1,
            returnRide: !!lastQuote.returnRide,
            waitOnSpot: !!lastQuote.waitOnSpot,
            quote: lastQuote,
            extras: selectedExtras,
            beverages: selectedBeverages,
            snacks: selectedSnacks,
            extrasTotalPrice: extrasTotalPrice,
            playlistGenre: (function() {
              var playlistExtra = selectedExtras.find(function(e) { return e.name === 'playlist'; });
              return playlistExtra && playlistExtra.genre ? playlistExtra.genre : null;
            })()
          })
        });

        if (!res.ok) throw new Error("Booking request failed");

        var data = await res.json();

        // Update lastQuote with extras total for display
        if (lastQuote) {
          lastQuote.extrasTotalPrice = extrasTotalPrice;
          lastQuote.totalPrice = (lastQuote.price || 0) + extrasTotalPrice;
        }

        bookingMessageStep2.textContent =
          "Thank you for your reservation. Your ride is almost confirmed. You will receive a confirmation email and WhatsApp message shortly where you can manage your reservation.";

        // Urbixx_ID tonen
        var urbixxId = data.urbixxId || (data.booking && data.booking.id);
        if (urbixxId && bookingIdWrapper && bookingIdValue) {
          bookingIdValue.textContent = urbixxId;
          bookingIdWrapper.style.display = "block";
        }

        // Payment opties (full + deposit)
        var fullUrl = data.checkoutUrlFull || data.checkoutUrl || null;
        var depositUrl = data.checkoutUrlDeposit || null;
        var hasAnyPayment = false;

        if (paymentLinkWrapper) {
          if (paymentFullLink) {
            if (fullUrl) {
              paymentFullLink.href = fullUrl;
              paymentFullLink.style.display = "inline-block";
              hasAnyPayment = true;
            } else {
              paymentFullLink.style.display = "none";
            }
          }

          if (paymentDepositLink) {
            if (depositUrl) {
              paymentDepositLink.href = depositUrl;
              paymentDepositLink.style.display = "inline-block";
              hasAnyPayment = true;
            } else {
              paymentDepositLink.style.display = "none";
            }
          }

          paymentLinkWrapper.style.display = hasAnyPayment ? "flex" : "none";
        }

        // Google Calendar link
        if (data.googleCalendarUrl && calendarLink && calendarLinkWrapper) {
          calendarLink.href = data.googleCalendarUrl;
          calendarLinkWrapper.style.display = "flex";
        }

        // Show "Manage my reservation" button
        if (reservationsAfterWrapper) {
          reservationsAfterWrapper.style.display = "block";
        }
      } catch (err) {
        console.error(err);
        bookingMessageStep2.textContent =
          "We were unable to complete your booking. Please try again.";
        finalBookingBtn.disabled = false;

        if (paymentLinkWrapper) {
          paymentLinkWrapper.style.display = "none";
        }
        if (bookingIdWrapper) {
          bookingIdWrapper.style.display = "none";
        }
        if (paymentFullLink) paymentFullLink.style.display = "none";
        if (paymentDepositLink) paymentDepositLink.style.display = "none";
        if (calendarLinkWrapper) {
          calendarLinkWrapper.style.display = "none";
        }
        if (reservationsAfterWrapper) {
          reservationsAfterWrapper.style.display = "none";
        }
      }
    });
  });